var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 578 120"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#logo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__b)",
  d: "M67.429 0c20.081 0 34.612 5.551 46.367 16.327 12.408 11.428 18.612 26.285 18.612 44.408 0 11.102-2.939 21.55-8.979 31.02C111.837 110.531 92.735 120 66.123 120c-19.919 0-35.756-5.388-47.51-16.327-6.368-5.877-11.103-12.898-14.368-21.06C1.469 75.428 0 66.285 0 58.285c0-11.592 2.939-20.572 8.816-30.204C20.245 9.796 40.653.327 67.43 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__c)",
  d: "M67.755 3.755c18.94 0 32.49 5.225 43.592 15.51 11.755 10.613 17.633 24.653 17.633 41.633 0 10.449-2.776 20.245-8.49 29.224-10.939 17.633-28.898 26.613-54.04 26.613-18.776 0-33.634-5.225-44.735-15.511A55.1 55.1 0 0 1 8.327 81.633C5.55 74.939 4.245 67.755 4.245 60.245c0-10.939 2.776-20.898 8.327-30.04 10.775-17.307 30.04-26.123 55.183-26.45"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__d)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M70.368 24.327h.653c1.143.326 3.755-.654 4.081.653-1.469-.49-4.245.653-4.734-.654Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__e)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M72.163 27.265c.98-.163 1.143.49 1.143 1.143-.49-.163-.49.163-.653.653-.653-.163-.49-1.143-.49-1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__f)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M71.02 29.551h1.307v.653c-.817 0-.817.816-1.796.653-.163-.816.326-.816.49-1.306Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__g)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M52.898 30.694v-.653h1.306c0 .98-.49 1.47-1.143 1.796-.163-.327-.163-.817-.163-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__h)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M75.102 31.347c.164-.49 0-1.143.653-1.143h.654c0 .653-.49.653-.654 1.143v1.143c-.653-.163-.816-.49-.653-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__i)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M105.96 57.47c-.817-.164-2.123.163-2.286-.654.816.164 2.122 0 2.286.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__j)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M84.408 65.143c1.633-1.633 1.47 1.796-.653 1.143 0-.653.49-.653.653-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__k)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M86.204 68.082c-.163-.98 3.266-.98 2.286.653-.98 0-1.306-.817-2.286-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__l)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M52.898 68.571c-.49-.163-1.143 0-1.143-.653h2.286c-.163.653-.49.817-1.143.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__m)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M65.143 69.714v2.939h-.653c.327-.816-.653-2.939.653-2.939Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__n)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M49.306 78.53c-.816 0-.816-.816-1.796-.652-.163-1.307 2.123-.327 2.939-.653 0 .653-.49.653-.653 1.142 0 .164-.163.164-.49.164Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__o)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M47.02 79.184h-.652c-.49-2.123 1.959-.98 1.795 0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__p)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M45.878 80.327c-.49-2.613 1.143.49 1.143-1.143h1.142c0 .653.817.98 0 1.142z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__q)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M86.204 80.816h.654c.326.49.49.98 1.142 1.143-.326.653-.816 1.143-1.796 1.143h-.653c-.163-.98.653-1.143.653-2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__r)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M25.96 82.612c0-.98.652-1.306 1.795-1.143 0 .654-.49.653-.653 1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__s)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M28.408 82.612V81.47h2.939c0 .654-.49.653-.653 1.143h-2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__t)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M69.878 83.265c-.164-.816-1.307-.653-1.796-1.143.163-1.306 2.612-.326 2.938 0h1.143c0 .98-1.632.327-1.796 1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__u)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M93.225 81.47h1.142c1.796 1.142-1.796 2.122-1.142 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__v)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M32.98 82.612v-.653h2.449c-.164.816-1.47.653-2.45.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__w)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M54.04 82.612c-.326 0-.652-.163-.652-.653h.653c.816 0 1.632-.163 1.796.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__x)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M54.694 25.47c1.796-1.307 2.286-3.919 5.224-4.082v.653c-1.469-.163-1.796.816-2.285 1.796-1.143.326-1.633 1.306-2.94 1.632Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__y)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M34.775 42.939c1.306-7.02 8.164-10.45 12.898-14.53v.652c-.653.49-1.142 1.143-1.796 1.796-.816 2.776-3.102 4.245-5.877 5.225-.653.816-3.429 2.449-1.796 3.428v1.143c-.816.653-1.143 1.633-1.796 2.286z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__z)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M32.98 44.735v2.285c-1.633.327-3.918-1.959-3.429 1.143-2.938-1.632 1.143-3.428 2.939-1.796v-1.796c.163.164.327.164.49.164Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__A)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M31.347 51.755c-1.47 1.796-4.408-3.755-1.143-.653 0 .653.653.49 1.143.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__B)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M25.96 58.122v-1.795c1.959-.327 2.938-1.796 5.224-1.96.326.49-.163.653-.49.817-1.959-.653-.49 1.959-2.285 1.143-1.96-.49-1.307 1.632-2.45 1.795Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__C)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M19.102 65.143c1.633-1.143 1.306-4.082 4.082-4.082-2.286.49-.817 4.572-4.082 4.082Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__D)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M13.715 65.633c.653-.164.98.163 1.142.653.98-.164 2.286-3.102 3.429-1.143-1.143-.49-3.265.98-1.796 1.143-.49 1.632-1.96-.327-2.939 0 .163-.164.163-.327.163-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__E)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M17.796 72.653c.327 1.306.98-.653 1.796.653.816-.326-.163-.816 0-1.796h1.796v1.796c-1.306.327-4.408 1.47-4.735-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__F)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M25.47 73.96c3.755.489 3.918-2.613 7.02-2.94.653.164.326 1.143 1.143 1.143 0 .98-.653 1.306-.653 2.286.49 1.47 4.081 1.633 5.224.653.817-.653.49-2.612 2.939-1.796h.653c-2.449 1.47-5.714 5.714-9.306 1.796-.653-1.306.163-2.286.653-2.939-4.082-.653-5.224 4.408-9.306 1.796z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__G)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M43.592 72.653c.163-.816 1.796-.816 1.796 0 0 .49.653.49 1.143.653-.98 1.96-1.47-1.306-2.94-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__H)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M25.47 81.47c2.122-1.633 5.714-.654 9.306-1.796-.653 1.142-3.429.163-3.429 1.795h-2.939a2.07 2.07 0 0 0-2.938 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__I)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M30.694 82.612c.49-.49 1.306-.653 2.286-.653v.653c-1.47-.49-3.266 1.796-4.082 0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__J)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M42.939 82.123h1.143v1.142c-.98-.98-2.45.653-4.572.164-.653-.164-.326-.654 0-.654.817-.326 2.94.654 2.94-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__K)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M51.102 82.612c.327-1.959 1.96-.49 2.286.653-.817-.163-.98-.98-1.796-1.142.163.49-.163.49-.49.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__L)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M58.775 78.53c.164-.49.654-.652.654-1.142.49-.327.979-.653 1.142 0-.49 1.796.653 2.122.653 3.428-1.306-.163-1.306-1.47-1.142-2.938-.654.163-.817.653-1.307.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__M)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M64.653 82.449c-.49-.326-1.143-.326-1.143-.98.49.164.49-.163.653-.653.49.164.327.98.49 1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__N)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M96.653 83.755c-.98.816-5.061.163-4.082-.653 2.45-.163 2.286.816 4.082 0z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__O)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M100.082 83.755c0-.49.326-.49.653-.49-.817-1.47-2.776-.326-2.94-1.143.654-.98 4.572.327 2.94 1.796-.164-.163-.327-.163-.653-.163Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__P)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M88.98 74.449c-.164-.49.163-.49.652-.653h.654c.49.49.326 1.633 1.142 1.796 1.307 1.306 2.45-.98 3.429-1.796 1.143-.327 1.47.326 2.286.653h1.143c-.49 2.122-2.123.653-2.94 0-2.122 4.408-4.57 0-6.367 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__Q)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M103.674 75.592c1.142.163 1.796-.163 1.796-1.143h.653c.326 2.122-1.796 1.796-3.429 1.796-.163-.653.49-.49.98-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__R)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M109.551 71.02c1.306-.326 1.796-1.306 2.939-1.795 1.306.163.49 2.612 1.796 2.938-2.286-.163-2.449-1.143-6.368-.653 0-.49.654-.49 1.143-.653 0 .163.164.163.49.163Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__S)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M115.919 72.653c3.102.327 3.102-2.286 5.877-2.286v1.143c-.49-.163-.49.163-.653.653-.653-.163-.326-.653 0-.653-.816-1.143-3.918 3.429-5.877 1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__T)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M121.143 63.347c2.449-.163 2.939 2.612 4.735 3.428 0 .98.326 2.45-.653 2.286.653-3.102-2.123-2.612-2.939-4.081-.163-.654-.98-.817-1.143-1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__U)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M119.347 62.857c-.163-.49-.49-.653-1.143-.653v-.653c1.469-.163 1.796.816 2.286 1.796-.49 0-.653-.49-1.143-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__V)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M111.837 56.98c3.428 0 6.367 1.143 6.367 4.081-1.469 0-.816-2.285-2.285-2.285h-1.143c0-.49-.653-.49-1.143-.654-.163-.816-1.796-.163-1.796-1.142Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__W)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M101.878 48.327c1.306 1.142 1.469 2.938 2.939 3.918-.327.49-.654.98-.654 1.796.164 1.633-1.469 1.959-1.142 2.286 2.938-.817 5.714-.654 8.163.653-2.286-.327-3.265.49-5.225.653-.163-.817-1.469-.653-2.285-.653h-2.449c-.164-2.45 2.612-1.633 2.122-4.409-.326-.653-1.306-2.285-1.469-4.244Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__X)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M91.918 38.857c-1.632-.163-.653-2.775-2.939-2.286V35.43c1.307.98 2.776 1.469 2.94 3.428Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__Y)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M84.898 33.633c-.163-.49-.653-.653-.653-1.143.98.163 1.306.98 1.143 2.285h-.653c.163-.326.163-.816.163-1.142Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__Z)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M81.47 29.551c1.143.816 2.449 1.306 2.939 2.939-1.633.163-1.307-1.796-2.94-1.796V29.55Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aa)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M63.347 30.694c0-.816-.163-1.633.653-1.796-1.633-3.429-5.388 1.633-7.51-.653-.653-1.796.98-1.47 1.143-2.286 1.632.327 7.836-.49 7.51-4.245 2.286-.816 3.755.327 4.735 1.306v.654c-.817-.654-2.123-.654-2.94-1.143v1.796c.98.326 0 2.775 1.144 2.938.49.327.98.49 1.143 1.143-.98.49-3.102 0-2.94 1.796h-.652c-.327-.98-.653 0-.653.653-2.286-.816-.164 2.612-2.286 1.796 0-1.143.653-1.143.653-1.96Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ab)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M60.408 21.878c.49-1.633 2.45.326 1.796 1.796-.49.49-1.306.652-2.285.652.163-.652.979-.652 1.795-.652-.163-.49 0-1.143-.653-1.143.164-.49-.163-.49-.653-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ac)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M57.47 23.674c.49-.817.816-1.796 2.285-1.796h.653c.327 0 .654.163.654.653-1.96-.49-2.45.653-3.592 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ad)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M57.47 23.674c.98-.49 1.47-1.633 3.428-1.143.49 0 .49.653.653 1.143-.816 0-1.632-.164-1.796.652-.49.98-2.775-.163-2.285 1.796-.327.98-1.47.49-.653 2.286 1.632 2.286 8-6.694 8.326-.326-1.143 0-1.959 1.959-1.796 2.775-1.143.653-1.959 3.102-2.285 0 1.306 1.306 2.122-.49 1.795-2.286-2.122-.163-4.571 2.94-7.02.653-.653-1.795-.327-1.469.653-2.938 0-1.143-1.96.653-3.428 0 .163-.653 1.142-.49 1.795-.653 1.143-.49 1.633-1.47 2.613-1.96Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ae)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M66.939 24.327V22.53c.816.653 2.122.49 2.939 1.143v.652c-.817 0-1.306.327-1.796.654-.49-.164-.653-.654-1.143-.654Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__af)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M77.388 24.816c.98 0 1.306.653 2.285.653.98.817 0 3.429 1.796 3.429v1.306c-.816-.98-2.122-1.796-1.796-4.082-.98 0-1.796-.163-2.285-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ag)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M81.47 30.694c1.632 0 1.306 1.796 2.939 1.796 0 .653.49.653.653 1.143-1.633-.327-2.286-1.633-3.429-2.286-.163-.327-.163-.49-.163-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ah)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M88.98 36.571c2.122-.49 1.306 2.286 2.939 2.286v.653c-.327 1.633 1.142 1.143 1.796 1.796 1.469.816 2.775-1.306 2.938 0-.816.653-2.122.49-2.285 1.796-3.102-1.47-3.429-6.04-7.02-7.02 1.305-1.306.652 0 1.632.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ai)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M97.306 41.143c1.306-.163 1.796.49 1.796 1.796-.816-.163-.98-.98-1.796-1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aj)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M103.51 52.408c.98 2.45-1.959 2.123-2.122 4.572-.163.49-.49.653-1.143.653-.327-3.102 1.959-2.45 3.265-5.225Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ak)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M101.877 56.98h1.796c.164.816 1.47.49 2.286.653 1.959 0 2.939-.98 5.225-.653h.653c0 .98 1.632.326 1.796 1.142-5.225-1.306-7.837 1.796-11.756-1.142Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__al)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M114.776 58.776h1.143c.49 1.469 1.143 2.775 2.285 3.428.654-.163.98.163 1.143.653.164 1.47 1.796 1.633 2.939 2.286.816 1.47 3.592 1.143 2.939 4.082-.49-.164-.49.163-.49.49h-.653c.49-4.572-7.347-5.552-9.306-10.94Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__am)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M114.776 71.51c.816.327 4.408.98 5.224-1.796 2.613-.653 2.776 3.102 4.082.653 0 1.633-.163 3.266-2.286 2.94-.49 0-.49-.654-.653-1.144 0-.326.163-.653.653-.653v-1.143c-2.775 0-2.775 2.776-5.877 2.286-.327-.49-.49-.98-1.143-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__an)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M109.551 70.857c.49-1.143 1.143-1.959 2.939-1.632-1.143.49-1.633 1.469-2.939 1.632Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ao)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M105.47 73.96c2.122.326 1.632-5.062 3.428-2.94-.49.164-1.143 0-1.143.654v1.795c-.816 0-1.142.653-2.285.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ap)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M101.877 75.592c.49-2.45 2.449.326 3.429-1.143 0 .98-.653 1.306-1.796 1.143 0-.817-1.143-.327-1.633 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aq)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M91.429 73.96c.49.163.653.489.653 1.142 1.632-.163 3.102-5.224 5.061-.653-.816-.163-.98-.816-2.286-.49-.98.816-2.122 3.102-3.428 1.796z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ar)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M86.694 72.653c-.816-.653-2.122-.49-2.286-1.796-.163-.49-.653-.653-.653-1.143 1.306.49 1.306 2.286 2.94 2.286z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__as)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M77.388 69.225c0 4.408 2.285.326 4.734.653-.163.816-1.796.163-1.796 1.142-.816 1.47-1.959.98-3.428.654v-2.286c.163-.163.327-.163.49-.163Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__at)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M78.04 69.225h1.144c0-.817.163-1.633-.653-1.796v-.654c1.795 0 1.632 3.43-.654 2.94.164-.164.164-.327.164-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__au)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M76.735 65.143c.163-.653-1.633-1.96-1.796-.653-.98.163-.98-.49-1.796-.653H72c1.143-1.47 2.612.653 4.082-.653.326 1.47 2.285 1.142 1.796 3.591-1.143.164-.164-1.632-1.143-1.632Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__av)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M72.653 73.96c-1.143-1.633-.163-3.266-2.285-2.94-.817-1.632 1.632-2.938 0-3.428 0-.327.163-.653.653-.653.326.49.653.98.653 1.796-.327.49-1.306 2.122.653 1.796.816.163.49 1.469.653 2.285-.327.327-.327.653-.327 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aw)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M72.653 73.96c.49.489 1.306.652 2.286.652 1.143 1.633 2.939 2.45 5.878 2.286v.653c-4.572.816-5.715-1.633-8.164-2.939z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ax)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M86.694 80.816c.816.164 1.143.817 2.286.653-.164.49-.49.654-1.143.654-.653-.164-.817-.654-1.143-1.307Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ay)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M74.45 79.674c3.918 2.448 8.652 1.959 11.754 1.142-2.122-.653-1.959 1.306-2.938 1.796H80.98c.163-1.306-2.123-.326-2.939-.653-1.47-.49-2.286-1.633-3.592-2.285Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__az)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M72.164 79.184c-1.47.163-1.796-.98-2.94-1.143-.163-.49-.652-.653-.652-1.306 0-1.143-1.96-.327-1.796-1.796 2.449.98 3.102 3.265 5.388 4.245Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aA)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M65.143 70.367c.98.98.327 3.429 1.796 4.082-.816-.163-.98-.98-1.796-1.143v-2.939Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aB)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M66.286 78.04c-1.306-1.305-1.143-8.163-1.143-8.163-1.306-.163-.326 2.123-.653 2.94-.49 0-.49.652-.653 1.142-2.286 2.123 2.286 3.918.653 1.143.98-.163 1.143.49 1.143 1.143 0 .98.653.98.653 1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aC)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M66.286 78.53h1.796c-.164 1.307.163 2.123 1.142 2.286.98-.163.98.49 1.796.653v.653c-.326-.326-2.775-1.306-2.938 0 .49.49 1.632.327 1.796 1.143h-.654c-.816-1.632-2.449.98-2.938-.653.98 0 .49-1.47 1.796-1.143.163-1.795-1.633-1.469-1.796-2.938Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aD)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M61.062 77.388c-.49 2.612.98 3.265 2.938 3.428 0 .327-.163.653-.653.653-1.143.327-1.47-.326-2.285-.653 0-1.306-.98-1.796-.654-3.428z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aE)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M61.551 73.96c1.306.162-.163 2.611-.653 2.938v-1.143c.49-.653.816-1.143.653-1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aF)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M58.775 69.714c.49 0 .49.653.654 1.143.49 0 .49-.653.652-1.143h.654c0 1.633-.98 1.143 0 2.286-.98.163-.98-.49-1.796-.653-.164-.327-.164-.98-.164-1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aG)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M58.776 69.225v2.449c0 .816-.163 1.632.653 1.795.163.49.653.653.653 1.143v1.143c.163.653-.163.98-.653 1.143.326-1.306-2.612-5.224-.653-7.673Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aH)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M54.041 82.122c2.286-.98 3.102-3.591 5.225-4.734 0 .653-.49.653-.654 1.143-.98.49-.816 1.795-2.285 1.795-.327 1.143 1.796 2.45-.653 2.286 0-.653-.817-.653-1.633-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aI)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M53.388 82.122c-.816-.163-.653-1.306-1.143-1.796-.163-.49.163-.49.653-.652-.163 1.142.653 1.306.49 2.448Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aJ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M54.04 79.184c.817-.653.817-2.286 1.797-2.94-2.123 1.144-3.919 2.45-5.878 2.287.163-.49.653-.653.653-1.143-.816.326-2.939-.653-2.939.653.98-.163.98.49 1.796.653-.163 1.47 1.143 1.306.653 2.939-.49-.327-.98-.653-1.142 0-.49 0-.49-.653-.653-1.143.816-.327 0-.49 0-1.143.163-.98-2.286-2.122-1.796 0h.653c0 1.633-1.633-1.47-1.143 1.143h-.653v-1.796c-1.796-.49-1.796.98-2.94 1.143.654 1.632 1.634-.817 2.287.653.163 1.306-1.633.653-1.796 1.796h-1.306V80.49c-.49.326-.98.653-1.143 0 .816-.653 4.081-1.796.653-1.796h-.653c.163-.653 1.143-.49 1.796-.653 1.47-.163 3.265-.327 4.081-1.143h1.143c.98-.327 3.429.653 3.429-.653 2.775 0 2.449-3.265 3.428-5.225 1.306.817-.653 3.103-.653 4.735 2.613.49 1.306-2.939 3.429-2.939-.163 2.286-1.796 6.694-3.102 6.368Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aK)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M50.613 70.367c1.795-1.142.816.327.653 1.796.163.653-.164.98-.654 1.143-.326 0-.653-.163-.653-.653.817 0 .49-1.306.653-2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aL)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M41.143 72.653c1.959-.653 4.245-2.449 5.877 0h-1.796c0-.816-1.632-.816-1.795-.163-.98-.163-.98.653-1.796.653h-.654c.164 0 .164-.163.164-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aM)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M33.633 72.163c1.632.49-.98 2.123.653 2.939 1.959.49 2.285-.816 4.081-.653v.653c-1.142.98-4.734.816-5.224-.653-.163-1.143.49-1.306.49-2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aN)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M25.47 73.306c3.592.49 3.102-3.102 7.02-2.286-3.102.327-3.102 3.429-7.02 2.94z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aO)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M17.796 72.653c1.47-.49 1.47-2.286 4.082-1.796 0 .98.49 1.47 1.142 1.796-.326 1.633-.98-.816-1.796-.653v-.653H19.43c-.164.98.816 1.47 0 1.796-.653-1.143-1.307.816-1.633-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aP)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M13.714 66.286c.98-.327 2.45 1.632 2.939 0-1.47-.327.49-1.633 1.796-1.143h.653c3.265.653 1.96-3.592 4.082-4.082.98 0 1.469-.49 1.796-1.143 2.448 0 1.795-2.938 3.428-3.428 1.96.653.49-1.96 2.286-1.143V56c-3.592 3.265-7.837 5.714-9.96 10.449-3.754-1.306-6.04 3.592-9.959 1.143 1.47 0 1.96-.98 2.94-1.306Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aQ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M31.347 55.837c.49-1.633 1.306 1.796 2.286 0 0 .653-.49.653-.653 1.143-.816-.164-.98-.98-1.633-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006227",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.161,
  d: "M33.633 55.837v-.653c1.143.49-.164 3.265-1.143 3.428-.163 1.47 2.612-.326 1.796 1.796 1.47 0 2.775-.326 3.428-1.143h1.143c.817-.653 1.143-1.632 1.796-2.285v-1.143c1.796 1.143 5.225 3.265 5.225-1.143.49.163.49-.163.653-.653.816-.163.163-1.796 1.143-1.796h.653c.49.816.816 1.796 2.285 1.796 1.96-1.143-.98-2.123-.653-3.429h-2.285c-.817 1.47-1.796-.98-2.286.653-.49.327-.98.49-1.143 1.143-.49.98-2.776-.163-2.286 1.796-.49.163-.653.653-1.143.653-1.306.163-.653-1.633-1.796-1.796h-.653c-1.142.49-2.122.98-3.428 1.143v-1.143c-.49-1.796-3.429-1.306-4.735-2.285 0-2.123.653-1.633 0-3.43 1.306 0 1.796.98 3.429.654.326-.49.653-.98 0-1.143-.49-1.796.98-1.796.653-3.428h2.449c.816-.49 1.796-.817 1.796-2.286V40c-.163-.653.163-.98.653-1.143 2.612-1.306 3.755-4.081 7.02-4.735v-2.938c.49-.653 1.143-1.143 1.796-1.796h1.143c0 .98.49 1.47 1.143 1.796v1.306c-1.96.653-5.225 3.265-3.429 5.877 1.143-2.449 5.388-1.632 5.225-5.224 1.47.163 2.449-.327 2.938-1.143.164-.653-.163-.98-.653-1.143h-.653c-.816-1.143-3.265-.653-2.938-2.939.49.327.98.653 1.142 0 .49 0 .49-.653.654-1.142h.653c1.469.653 3.428-1.143 3.428 0-.816 1.306-1.143.98-.49 2.938 2.123 2.45 4.735-.816 6.858-.49.326 1.96-.49 3.592-1.796 2.286h-2.449c0 .817-.164 1.633.653 1.796h.653c.163 2.776-2.286-.816-2.286 1.796h-.653c-.98 0-1.47.49-1.796 1.143s-.816 1.143-1.796 1.143c-.816.653-2.612.49-2.286 2.285-.49-.163-.49.164-.653.654-1.143 0-2.775 2.612-1.143 3.428 1.796-.816 2.123-2.939 3.43-4.082h.652c.98 0 1.306.654 2.286.654 1.306-.164-.817-1.633.653-2.286 1.796-.653 1.47.98 2.286 1.143 1.469-.164.163-1.96 0-2.286 0-.49.653-.49 1.142-.653 1.143-.816 3.102-.816 3.43-2.286.489-.163.652-.653 1.142-.653h1.796c0-.98-.653-1.306-.653-2.286h.653c1.143-.49 3.102-2.122 3.428 0-1.142-.163-1.796.164-1.796 1.143-.49 0-1.795 1.96-.653 1.796.164.98-.49.98-.653 1.796v.653c.817.327 3.592 1.143 4.082-.653 0-1.96-1.96 0-1.796-2.939.98-.49 3.102 0 2.939-1.796h.653c.163.654.653.327.653 0 .653.327.653 1.307 1.796 1.143-.163.653.163.98.653 1.143.163 1.96 3.428 1.47 2.286-1.143-.49-.49-1.143-.816-1.796-1.143h-.653c-.653-.816-.653-2.449-1.796-2.938v-.653c-.98 0-2.286-.327-2.286.653-.49-.327-.98-.653-1.796-.653-1.306.163-1.796-.49-1.796-1.796.49-.327.98-.653 1.796-.653h.653c.49 1.306 3.266.163 4.735.653h2.449v.653c.49.49 1.306.653 2.286.653-.327 2.285.816 3.102 1.795 4.081v1.307c1.307.653 1.96 1.959 3.43 2.285v1.143c.162 1.143 1.958.327 2.285 1.143 3.592.98 3.918 5.388 7.02 7.02.164-1.142 1.633-1.142 2.286-1.796h.653v.654c.816.163.98.98 1.796 1.142.163.653-.163 1.633.653 1.796 1.633 1.633 1.469.98 2.286 3.429 0 .326 1.469 4.081 1.469 4.081-.98 3.103-3.592 2.286-3.265 5.225.653.163.979-.163 1.143-.653h.653c3.918 2.775 6.53-.163 11.755 1.143.49.163 1.143 0 1.143.653 1.959 5.388 9.796 6.367 9.306 11.102v.653c-1.306 2.612-1.47-1.143-4.082-.653-.816 2.612-4.408 1.96-5.224 1.796-.49-.163-.49.163-.653.653-1.143-.327-.327-2.776-1.796-2.939-1.796-.326-2.449.653-2.939 1.796h-.653c-1.959-2.123-1.47 3.265-3.429 2.939v.653c-1.143 1.47-3.102-1.306-3.428 1.143h-.653c-.817-.653-2.123-.653-2.94-1.143h-1.142c-1.96-4.408-3.592.326-5.225.653.164-.653-.163-.98-.653-1.143H89.47c-.163-.816-1.795-.816-1.795 0-.98.163-1.143-.49-1.143-1.143v-.653c-1.633-.163-1.633-1.96-2.939-2.286h-1.796c-2.449-.326-4.571 3.919-4.735-.653h.653v.653c2.123.49 2.286-2.938.654-2.938h-.654c.49-2.286-1.469-2.123-1.796-3.429-1.469 1.306-2.938-.816-4.081.653-.49.327-.98.49-1.143 1.143v1.796c-.49-.163-.49.163-.653.653 1.633.49-.816 1.796 0 3.428 2.122-.326 1.143 1.143 2.286 2.94v.652c2.449 1.306 3.591 3.755 8.163 2.94 1.47 1.468 6.53 1.632 8.816.652-.163.49.163.49.653.653-.163.653-1.143.49-1.796.653-.49 2.286 2.776.653 2.286 2.94-.98.162-.98-.49-1.796-.654-1.143.327-1.47-.327-2.285-.653h-.654c-3.102.816-7.836 1.306-11.591-1.143H72.98c0-.49-.653-.49-1.143-.653-2.123-.98-2.939-3.265-5.225-4.082v-.653c-1.306-.653-.653-3.102-1.796-4.081 0 0-.163 6.367 1.143 7.51V80c.164 1.47 1.96 1.143 1.796 2.939-1.306-.327-.816 1.143-1.796 1.143h-1.796c-.163-.653.164-1.633-.653-1.796-1.796-.327-3.428-.817-2.938-3.429v-.653c.49-.326 1.795-2.775.653-2.939 0-.98-.49-1.47-1.143-1.796.163.164-.653 3.429-1.143 4.735v.653C56.816 80 56 82.45 53.714 83.592h-.653c0-.98-.653-1.306-.653-2.286 0-.49.653-.49 1.143-.653 1.306.327 2.939-4.082 3.429-6.367-2.123 0-.817 3.428-3.429 2.939-.163-1.47 1.796-3.919.653-4.735-.326-.816.653-2.939-.653-2.939h-2.286c-.49-1.633-.653-.98-1.306-.98-.163.98.49.98.653 1.796 0 .98.327 2.286-.653 2.286-.49.49-1.306.653-2.285.653.163-.49-.164-.49-.654-.653-1.795-2.449-3.918-.653-5.877 0-1.47 0-3.592-.49-2.939 1.796-1.796-.327-2.122.98-4.081.653-1.633-.816.98-2.449-.654-2.939-.816 0-.49-.98-1.142-1.143-3.755-.653-3.429 2.94-7.02 2.286-1.144.327-1.47-.326-2.286-.653-.654-.327-1.143-.816-1.143-1.796-2.613-.653-2.613 1.143-4.082 1.796h-1.143c-.163-.816-1.47-.49-2.285-.653-.164-.816-1.47-.49-2.286-.653-.653.163-.98-.163-1.143-.653v-.653c-.816-.327-3.918-2.776-1.143-2.939h1.143c3.918 2.449 6.204-2.449 9.96-1.143 2.121-4.735 6.366-7.184 9.958-10.449h.653c.817.163.98.98 1.796 1.143-.163-.163.327-.326.327-.816Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aR)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M37.715 59.265c-.654.817-1.96 1.143-3.43 1.143.98-2.122-1.958-.326-1.795-1.796.98-.163 2.286-3.102 1.143-3.428.163-.653.653-.98 1.143-1.143 1.306-.163 2.285-.653 3.428-.98-.816 2.286-4.571 1.306-4.081 5.061-.327 1.307.816 1.143 1.796 1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aS)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M38.857 57.47c.98.163.98-.49 1.796-.654-.653.817-.98 1.796-1.796 2.286v-1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aT)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M40.653 55.837v-1.143c.653 0 .653-.49 1.143-.653v1.306c.163 1.633 3.755 2.776 3.429 0-.163-.49.163-.49.653-.653 0 4.245-3.429 2.286-5.225 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aU)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M48.164 52.245c.816.326 1.469.816 2.285 1.143.164-1.633-1.796-1.306-1.796-2.939h1.143c-.49 1.47 2.612 2.449.653 3.428-1.306.327-1.796-.816-2.285-1.632Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aV)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M45.225 51.102c.653-1.633 1.632.816 2.285-.653v1.796c-.98 0-.326 1.633-1.142 1.796v-2.286c0-.653-.654-.49-1.143-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aW)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M44.082 52.245c.163-.653.653-.98 1.142-1.143.49.163 1.143 0 1.143.653-1.143-.326-1.47.327-2.285.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aX)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M30.041 51.102c-.49-.653-.816-1.633-.653-2.939-.49-3.265 1.96-.816 3.428-1.143.327 0 .654-.163.654-.653.653.164.326.653 0 1.143-1.796.49-2.123-.653-3.429-.653.653 1.796 0 1.306 0 3.429 1.306 1.143 4.082.49 4.571 2.285-.326-.163-.816-.326-1.632-.326-.98.163-.98-.49-1.796-.653-.327 0-.98.163-1.143-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aY)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M36.572 42.939c.653-.817.98-1.796 1.796-2.286 0 1.47-.98 1.796-1.796 2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__aZ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M38.204 39.51c-1.632-1.143 1.143-2.612 1.796-3.428.49 1.632-1.143 1.142-1.143 2.285-.49 0-.653.327-.653 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ba)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M40 35.755c2.776-.98 5.062-2.286 5.878-5.061v2.939c-3.266.653-4.408 3.265-7.02 4.734 0-1.306 1.632-.98 1.142-2.612Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bb)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M49.96 31.347c.49 0 .49.653.652 1.143-1.469 1.47-1.959.326-3.428 1.796 0 .816 4.245 1.306 3.428-.653 1.143 0 .327-1.96 1.796-1.796h.654c.653-.327 1.142-.653 1.142-1.796.49.163.653.49.653 1.143-.49.816-1.469 1.306-2.938 1.143.163 3.591-4.245 2.775-5.225 5.224-1.796-2.612 1.47-5.061 3.429-5.878-.164 0-.164-.163-.164-.326Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bc)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M51.755 27.265c-.163.653-.653.327-1.143 0-.326 2.286 2.123 1.796 2.94 2.94h-.654c-.98.162-.98-.49-1.796-.654-.98-.163-1.143.49-1.143 1.143-.653-.163-1.143-.816-1.143-1.796 1.96 1.143 1.47-.327 1.143-2.286 0-.49.653-.49 1.143-.653.163.49 0 1.143.653 1.306Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bd)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M57.47 34.122c0-2.448 2.449.98 2.285-1.795h.653v1.306c.164.49-.163.49-.653.653-.653-.164-1.469-.164-2.285-.164Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__be)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M53.388 36.571c.98 0 1.47-.49 1.796-1.142h.653c-.164.49-.653.653-.653 1.142-.49.327-.98.654-1.796.654.49.98 1.143.163 1.796 0v1.795c-.49-.326-1.633-.98-1.796 0h-.653c0-.49-.653-.49-1.143-.653.163-1.142 2.122-.49 1.796-1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bf)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M51.102 38.857c-.326-1.796 1.47-1.633 2.286-2.286.163 1.306-1.633.654-1.633 1.796 0 .327-.326.49-.653.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bg)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M55.184 37.061c.653.163.98-.163 1.143-.653.816 0 1.632.163 1.796-.653h.653c.163.327 1.47 2.286 0 2.286-.98-.327-.49-1.796-2.286-1.143-1.47.816.653 2.122-.653 2.286-1.143.163-1.306-.653-2.286-.653.163-.98 1.306-.327 1.796 0-.163-.327-.163-.817-.163-1.47Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bh)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M59.919 35.429c-.164-1.307 1.632-.654 1.796-1.796.98.163.98-.49 1.795-.653-.652 1.469-2.612 1.469-3.591 2.449Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bi)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M62.857 32.49c2.286.816.163-2.612 2.286-1.796 1.143 1.306-.163.653-.653 1.796-.653 0-.653.49-1.143.653-.816 0-.816.816-1.796.653h-1.143v-.653c1.306.163 1.633-.49 2.45-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bj)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M65.143 30.694c0-.653.327-1.47.653-.653-.163 1.143.653 1.306.653 2.286h-1.796c.327-.98 1.633-.327.49-1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bk)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M66.286 30.04c-.98-2.285.816-2.285 2.939-1.795.98 2.122.816-1.306 2.285-.653v1.796h-.653c-.49.163-.653.653-1.143.653-.326-2.123-2.285-.49-3.428 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bl)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M68.082 31.347c.163 1.306 2.122 0 2.286-.653.98.163.98-.49 1.796-.653.163 1.796-1.96 1.143-2.94 1.796-.163 2.939 1.797.98 1.797 2.939-.49 1.632-3.266.816-4.082.653v-.654c1.306-.163 2.286.164 2.939.654 1.143-.327-.98-2.45-2.286-2.286-1.306 0 0-1.796.49-1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bm)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M75.592 32.49h.653c.98 2.285.98-1.306 1.796-1.143.98 2.612-2.123 2.939-2.45 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bn)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M73.96 27.265c.979.49 1.142 2.123 1.795 2.94-.49 0-.49.652-.653 1.142-1.143.163-1.143-.816-1.796-1.143 0 .327-.49.653-.653 0 .49-.326.98-.653 1.796-.653.163-.653-.163-.98-.653-1.143.163-.49.163-.816.163-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bo)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M68.082 24.816c-.163 1.306.49 1.796 1.796 1.796 0 2.123-1.96-1.306-1.796.653-1.143-.163-.163-2.612-1.143-2.939.49 0 .653.49 1.143.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bp)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M68.082 27.265c-.163-1.796 1.632 1.47 1.796-.653.816 0 1.306.327 1.796.653v.653c-1.47-.816-1.47 2.776-2.286.653-.327-.816-.816-1.142-1.306-1.306Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bq)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M71.51 27.265c.164-.816 1.47-.49 2.286-.653v1.796c-.653.327-.653 1.306-1.796 1.143h-.653v-1.796c.163-.163.163-.326.163-.49Zm1.143 1.633c0-.327.164-.653.653-.653 0-.653-.163-1.306-1.142-1.143 0 .816-.164 1.796.49 1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__br)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M47.674 28.245c2.285.98 1.143-1.47 2.285-1.633.327 1.96.817 3.429-1.142 2.286h-1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bs)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M72.164 29.551c1.142.163 1.142-.816 1.796-1.143.49.163.653.49.653 1.143-.817 0-1.307.327-1.796.653h-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bt)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M81.307 28.898c-1.796 0-.654-2.612-1.633-3.429 1.796 0 .653 2.613 1.632 3.429Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bu)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M51.755 31.347c-.49 1.633-1.796-1.306-.653-1.796.816 0 .816.816 1.796.653v.49c-.653.163-.98-.163-1.143-.653-.816.163-.653 1.306 0 1.306Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bv)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M49.96 30.694c0-.653.163-1.306 1.142-1.143-1.306.49 0 3.265.653 1.796.49-.163.49.163.653.653-1.306-.163-.653 1.633-1.796 1.796v-1.143c-.163-.49 0-1.143-.653-1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bw)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M61.061 30.694c.327 3.102 1.143.653 2.286 0 0 .816-.816.816-.653 1.796-.653.163-.98.816-2.286.49v-.653c.816-.327 0-.49 0-1.143v-.653c.327.163.49.163.653.163Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bx)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M69.878 30.04c.653 0 .653-.489 1.143-.652-.164.49-.653.653-.653 1.143-.164.49-2.123 1.959-2.286.653-.163-.98.49-1.306 1.796-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__by)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M75.592 31.347c.163-.49.653-.653.653-1.143.653.327 1.306.653 1.796 1.143-.817-.163-.816 3.428-1.796 1.143 1.306-.327.326-2.776-.653-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bz)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M59.265 32.49c-.653-.163-.653-.98-.653-1.796h1.796v.653c-.98-.327-.98.326-1.143 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bA)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M75.592 31.347c.98-1.633 1.959.816.653 1.143h-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bB)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M59.919 34.123c.326 0 .653-.164.653-.654h1.143c0 1.143-1.96.327-1.796 1.796-.49.164-1.143 0-1.143.653h-.653c-.163-1.306 1.632-.653 1.796-1.795Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bC)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M50.612 33.633c.816 1.796-3.428 1.469-3.428.653 1.469-1.47 1.959-.327 3.428-1.796z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bD)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M57.47 34.123h2.285c0 1.142-1.959.326-1.796 1.795-.163.653-.98.653-1.795.653 0-.653 2.449-1.142.653-1.795v-.654z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bE)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M56.98 34.776c1.959.49-.653 1.142-.653 1.795h-1.143c0-.653.49-.653.653-1.142.49-.164.49-.654 1.142-.654Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bF)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M55.184 37.061c-.653.163-1.306.98-1.796 0 .816 0 1.306-.326 1.796-.653h1.143c0 .653-.49.816-1.143.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bG)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M52.898 38.857c-1.47 1.143-1.796 3.265-3.428 4.082-.49-1.96.653-2.45 1.142-3.429 0-.326.164-.653.654-.653.326 0 .653-.163.653-.653.163.163.98.163.98.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bH)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M49.306 42.776c-1.632-.98 0-3.266 1.143-3.43-.49 1.144-1.632 1.47-1.143 3.43Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bI)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M91.918 39.51c.817.327 1.47.98 1.796 1.796-.49-.653-2.122-.326-1.796-1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bJ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M34.123 42.939c.49 1.796-.98 1.796-.654 3.428.164.49-.163.49-.653.653v-2.285c.653-.49.49-1.633 1.306-1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bK)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M48.817 50.612c0 1.633 1.796 1.306 1.796 2.939-.817-.327-1.47-.816-2.286-1.143h-.653v-1.796z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bL)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M44.082 52.245c.816-.163 1.143-.816 2.285-.653v2.286c0 .326-.163.653-.653.653-.326 0-.653.163-.653.653-1.142 0-.816 1.632-2.285 1.143-.327-.49-.49-.98-1.143-1.143v-.653c1.143-.49 1.959-1.143 2.449-2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bM)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M45.225 55.184c.326 2.775-3.43 1.632-3.43 0 .654.163.98.653 1.144 1.143 1.632.49 1.143-1.143 2.285-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bN)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M44.082 52.245a5.16 5.16 0 0 1-2.286 2.286v-.653c-.49-1.796 1.96-.654 2.286-1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bO)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M34.122 58.122c-.653-3.755 3.266-2.938 4.082-5.224h.653c1.143 0 .327 1.96 1.796 1.796v1.143H40c-.163-1.143-1.96-.327-2.286-1.143-1.796.326.49 1.306 0 2.286-1.47-.164-2.775-.164-2.939 1.142z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bP)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M30.694 55.184c.326 0 .653-.164.653-.653 1.633 1.796 4.245-1.633 1.796-2.286.816 0 1.306.326 1.796.653v1.143c-.49.326-.98.49-1.143 1.143v.653c-.98 1.796-1.796-1.633-2.286 0h-.653c-.163-.327-.163-.49-.163-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bQ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M40 55.837c-.163.816-.98.98-1.143 1.796v1.142c-.816.327-2.939-.652-2.939.654-.98 0-1.959 0-1.796-1.143h.654c.163-1.306 1.469-1.306 2.938-1.143.49-1.143-1.796-1.96 0-2.286.327.49 2.286-.163 2.286.98Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bR)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M38.857 57.47c.164-.817.98-.98 1.143-1.797h.653v1.143c-.816.164-.816.817-1.796.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bS)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M25.96 58.122c1.142-.163.49-2.285 2.285-1.795-1.796.653-1.143 3.591-3.429 3.428.327-.653 1.143-.816 1.143-1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bT)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M118.204 62.204c-1.143-.816-1.796-1.96-2.286-3.428 1.47 0 .817 2.285 2.286 2.285v1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bU)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M97.306 62.204c1.306 1.306 2.123-.327 1.796-2.286-.98 0-1.47.49-1.796 1.143v.653c-1.47-.816.653-2.775 2.286-2.285 1.469.816-1.306 3.102 0 3.428-.326.49-.653.98-.653 1.796-1.143 0-.327-1.96-1.796-1.796.163-.326.163-.49.163-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bV)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M99.592 64.49c.49-.163.49.163.653.653.163.98.98 1.306 2.286 1.143.163.653-.163.98-.653 1.143-.49-1.143-2.612-.817-2.286-2.94Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bW)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M97.306 61.551v-.653c.163-.653.817-1.143 1.796-1.143.327 1.96-.49 3.592-1.796 2.286z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bX)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M122.286 65.143c-1.143-.653-2.612-.817-2.939-2.286.49.163.653.653 1.143.653h.653c.163.653.98.816 1.143 1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bY)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M99.592 64.49v-.653c.163-.653.979-.653 1.796-.653-.164.816.163 2.122-.653 2.285 0-.326-.164-.653-.653-.653 0 0 0-.326-.49-.326Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__bZ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M71.02 65.143c.164-.653.654-.98 1.143-1.143h1.143c-.163.816-1.47.326-1.796 1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ca)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M75.102 64.49c0-1.47 1.96-.163 1.796.653-.98.163-1.143-.653-1.796-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cb)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M84.408 65.143c-.163-.653 1.633-1.96 1.796-.653.817 2.285-1.632 1.47-1.796 2.939-.49-.164-.653-.49-.653-1.143 2.123.653 2.286-2.94.653-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cc)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M82.123 69.714h1.796c0 .653.49.653.653 1.143-1.306-1.306-1.96.49-4.082 0-.163-.816 1.47-.163 1.633-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cd)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M75.102 74.449c1.796 1.306 4.572 1.633 7.02 2.286H80.98c-2.94.163-4.735-.653-5.878-2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ce)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M72.164 70.367c.49-1.959 2.285 2.286.653 2.286-.164-.816.163-2.122-.653-2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cf)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M71.51 65.143c-.816 1.632 1.633 2.939 0 3.428 0-.816-.326-1.306-.653-1.796V64.98c.327.163.49.163.653.163Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cg)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M86.204 64.49h.653v1.796c-.816.653-2.122.49-2.285 1.796h-.653c-.817-.817-.98-2.94.653-2.94-.164.49-.653.654-.653 1.144-.164.653.163.98.653 1.143-.164-1.47 2.285-.654 1.632-2.94Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ch)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M9.633 66.939c1.306.163 2.122-.163 2.286-1.143h1.795v.653c-1.142.326-1.469 1.306-2.938 1.143H9.633z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ci)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M88.49 68.571c.98-1.632-2.449-1.632-2.286-.653.98 0 1.306.817 2.286.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cj)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M54.04 68.082c1.307-.164.327 2.122.654 2.938-1.143-.163-1.143-1.632-1.796-2.285.653 0 .98-.164 1.143-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ck)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M121.796 73.306c2.122.327 2.286-1.143 2.286-2.939v-.653h.653c.326 2.286-1.306 5.388-2.939 3.592Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cl)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M114.123 72.163c0-.326.163-.653.653-.653.653.163.979.653 1.142 1.143h-.653c-.816.163-.489-.327-1.142-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cm)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M60.408 72.163c.654.163 1.143.817 1.143 1.796 0 .816-.326 1.306-.653 1.796h-1.143v-1.143c1.306 1.306 1.306-.163 1.143-1.796-.816 0-1.633-.163-1.796.653-.653-.163-.653-.98-.653-1.795.98-.164 1.143.652 1.96.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cn)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M21.388 73.306v-1.143c.816-.326 1.47 2.286 1.796.653.816.164 1.142.817 2.285.653v.653h-1.796c-.98-.163-1.142-.98-2.285-.816Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__co)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M47.674 73.306c.98 0 1.796 0 2.449-.49-.163.49.163.49.49.49.163 1.306-2.123.327-2.94.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cp)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M65.143 73.96v-.654c.816.163.98.98 1.796 1.143v.653c-.163 1.306 1.633.653 1.796 1.796-.98.163-.98-.49-1.796-.653-.326-.816-.49 0-1.143 0 0-.653-.163-1.306-1.143-1.143 0-.49.49-.653.49-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cq)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M65.633 76.245c.653 0 .98-.816 1.143 0-1.796.49.653 1.632.653 2.286h-1.143v-.653c0-.653-.653-.653-.653-1.633Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cr)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M64.49 75.102c1.633 2.776-2.775.98-.653-1.143h1.143c.163.49-.327.653-.49 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cs)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M59.919 75.592h1.143v1.796h-.654c-.163-.653-.653-.327-1.142 0v-.653c.49 0 .653-.49.653-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__ct)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M101.877 75.592c.49-.327 1.633-.98 1.796 0-.489.163-1.142 0-1.142.653-.654.163-.98-.163-1.143-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cu)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M67.429 78.53c.163-.816-2.45-1.795-.653-2.285.816 0 .816.816 1.796.653 0 .653.49.653.653 1.143v.653c-1.47.163-.164 1.96 0 2.286-.98-.164-1.306-.98-1.143-2.286-.163-.163-.49-.163-.653-.163Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cv)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M42.45 78.04c.816-.979 2.285-1.305 4.08-1.142-.979.816-2.611.816-4.08 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cw)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M49.96 78.53c1.959 0 3.591-1.305 5.877-2.285-.817.653-.98 2.122-1.796 2.939-.49.163-1.143 0-1.143.653-.326 0-.653.163-.653.653h-1.796c0-.98-.653-.98-.49-1.96Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cx)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M82.122 76.735c2.776 1.142 4.735 1.142 8.164.653 1.306-.163 1.796.49 1.796 1.796-1.96.49.653 1.142.653 1.796-1.143.163-1.306-.654-2.286-.654.163-.816.98-.98 1.143-1.795-.163-.654-.98-.654-1.796-.654-2.123 1.143-7.184.817-8.817-.652v-.654c.327.164.654.164 1.143.164Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cy)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M49.306 78.53h.653c-.163.98.49.98.653 1.796 0 .49.653.49 1.143.654-.163.816-.98.816-1.143 1.632-1.796-.816-1.632.327-4.081.163-.164-.816-.817-1.142-.654-2.285h2.286c.164.49 0 1.143.653 1.143.164-.653.653-.327 1.143 0 .49-1.796-.816-1.633-.653-3.102Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cz)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M69.225 78.53v-.653c1.143.327 1.469 1.307 2.938 1.143.49.164 1.143 0 1.143.654-1.796.163-3.265-.164-4.081-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cA)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M35.429 81.47c.653-1.633 2.449.163 3.428 0v.652h-1.143c-.163-.98-1.469-.653-2.285-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cB)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M40.653 78.53h.653c3.592 0 .163 1.144-.653 1.796-.816.164-.98.98-1.796 1.143-.98.164-2.939-1.632-3.428 0h-.654c.164-.49.654-.653.654-1.142 0-.327.163-.653.652-.653 1.796 0 3.919.163 4.572-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cC)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M35.429 79.184c.326 0 .653.163.653.653-.49-.163-.49.163-.653.653-.49.49-1.306.653-2.286.653-.816.326 0 .49 0 1.143-.98 0-1.796 0-2.286.49.164-.49.49-.49.49-.98.163-1.633 2.939-.653 3.429-1.796-.164-.816.163-.816.653-.816Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cD)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M45.225 80.327c-.163.816-.98.98-1.143 1.795h-1.143c0-1.142 1.96-.326 1.796-1.796-.816-1.469-1.796.98-2.286-.652 1.143-.327.98-1.633 2.939-1.143-.163.653-.163 1.142-.163 1.795Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cE)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M73.306 81.47c.653-.817.163-.98 0-1.796h1.143c1.306.652 2.123 1.795 3.429 2.285v.653c-2.613 0-1.47 1.633-3.429 1.143 1.796-.816.98-2.286-1.143-2.286Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cF)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M50.612 80.327h1.796c.49.49.327 1.632 1.143 1.795-.163.49.163.49.653.653.163.49 0 .98-.653.654-.327-1.143-1.96-2.613-2.286-.654-.163 0-.49-.163-.653-.163.164-.816.98-.816 1.143-1.632-.49-.164-1.143-.164-1.143-.654Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cG)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M45.224 80.327h.654c-.327 1.142.326 1.469.653 2.285-.49-.163-.49.163-.654.653h-1.796v-1.143c.327-.816 1.143-.98 1.143-1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cH)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M32.98 82.122c0-.653-.817-.98 0-1.142.98 0 1.795-.164 2.285-.654 0 .654-.49.654-.653 1.143v.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cI)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M25.47 81.47a2.07 2.07 0 0 1 2.938 0v1.142h-1.143c.164-.49.654-.653.654-1.143-1.143-.163-1.796.164-1.796 1.143h-2.286c.163-.653.653-1.143 1.633-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cJ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M83.266 82.612c.98-.49.816-2.449 2.938-1.796 0 .98-.653 1.306-.653 2.286-.98 0-2.285.327-2.285-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cK)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M94.367 80.816c1.143-.326 1.47.327 2.286.653v.653c-.98 0-1.796-.163-2.286-.653h-1.142c0-.326-.164-.653-.654-.653 0-.653-2.449-1.142-.653-1.796.49.98.98 1.96 2.45 1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cL)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M70.368 83.265c.163-.816 1.796-.163 1.796-1.142.98 0 1.796.163 2.285.652-1.306 1.143-2.122-.326-4.081.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cM)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M71.02 81.47h2.286c2.123 0 2.939 1.469 1.143 2.285h-5.224v-.653h1.306c1.959-.816 2.775.653 4.081-.653-.49-.49-1.306-.653-2.285-.653h-1.143c-.163 0-.163-.163-.163-.327Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cN)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M96.653 83.265c-1.796.817-1.633-.163-4.082 0 0-.49-.653-.49-1.142-.653 0-.326-.164-.653-.654-.653.49-2.285-2.775-.653-2.285-2.939.653-.163 1.632.164 1.796-.653-.327 0-.654-.163-.654-.653.817 0 1.633-.163 1.796.653-.163.817-.98.98-1.142 1.796.98 0 1.306.653 2.285.653.49-.163.49.164.653.653-.49 2.123 3.102 1.143 1.143 0 .49.49 1.306.654 2.286.654h.653c0 .652-.163.979-.653 1.142Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cO)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M96.653 83.265c.49-.163.653-.49.653-1.142h.653c.164.979 2.123-.327 2.939 1.142-.326 0-.816-.163-.653.327-1.143-1.143-1.959 0-3.428.326-.164-.326-.164-.49-.164-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cP)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M51.755 27.265c-.49 0-.49-.653-.653-1.143h1.143c-.163.327 0 .98-.49 1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cQ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M52.245 31.837c0-.327-.163-.653-.653-.653-.653 0-.817-.98 0-1.143.163.49.49.653 1.143.653v1.143z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cR)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M66.939 34.776c0-.817.816-.817.653-1.796 1.306-.164 3.429 1.959 2.286 2.285-.817-.326-1.633-.653-2.939-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cS)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M55.184 35.429c.163-.654.816-1.143 1.796-1.143v.653c-.653 0-.653.49-1.143.653-.164-.163-.49-.163-.653-.163Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cT)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M35.919 59.265c-.164-1.306 2.122-.326 2.938-.653v.653H35.92Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cU)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M76.735 69.225c-.164-1.47 2.775.326 1.796-1.633.653.163.49.816.49 1.633h-2.287Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cV)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M12.082 71.51c.816.163 2.122-.163 2.285.653h-.653c-.816 0-1.633 0-1.633-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cW)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M14.367 72.163c.817.163 2.123-.163 2.286.653-.816-.326-2.939.653-2.939-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cX)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M38.204 74.449c-.816-2.286 1.306-1.796 2.939-1.796v.653c-2.286-.816-2.123.98-2.939 1.796z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cY)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M45.225 72.653h1.795c.327 0 .654.163.654.653H46.53c-.49-.163-1.306 0-1.306-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__cZ)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M64.49 72.653h.653v1.306H64c.163-.49 0-1.306.49-1.306Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__da)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M59.266 73.306c.163-.653.98-.653 1.796-.653.163 1.633.163 2.939-1.143 1.796 0-.653-.49-.653-.653-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__db)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M87.837 73.96c0-.817 1.633-.817 1.796 0-.327 0-.653.163-.653.652-.653 0-.98-.326-1.143-.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dc)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M90.286 73.96h1.142v1.795c-.816-.326-.653-1.47-1.142-1.796Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dd)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M105.469 73.96c1.143.326 1.47-.327 2.286-.654.327 1.306-.816 1.143-1.796 1.143h-.653c.163-.163.163-.327.163-.49Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__de)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M47.674 76.735c0-1.306 2.449-.327 3.428-.653 0 1.469-2.449.326-3.428.653Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__df)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M35.919 79.674c.163-.49-.164-.49-.653-.654 1.469-1.795 3.592.817 5.224-.653-.49 1.47-2.612 1.306-4.571 1.306Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dg)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M69.225 78.53c.816.98 2.285 1.307 4.081 1.144.163.816.653.98 0 1.795h-2.285c-.817 0-.817-.816-1.796-.653-.164-.326-1.47-2.122 0-2.285Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dh)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M35.429 81.47c.979 0 2.285-.327 2.285.652h-2.939v-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__di)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M42.45 82.122c.162 1.307-2.123.327-2.94.653.164-.49-.163-.49-.653-.653v-.653c.817-.163.98-.98 1.796-1.142.164.653.653.326 1.143 0v1.795z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dj)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M78.041 82.123c.816.326 2.939-.654 2.939.652H78.04z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dk)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M71.02 24.327c.98-1.143 5.388-.817 5.878.653h-1.796c-.326-1.47-2.939-.327-4.082-.654Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dl)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M59.266 32.49c0-.653.163-1.306 1.142-1.143 0 .653.817.98 0 1.143h-1.143Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dm)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M51.102 76.245c1.47-1.47 3.265-4.082 1.796-7.02-1.143.163-.163 2.612-1.143 2.938h-.653c.163-1.306 1.306-2.938-.653-1.796 0-.816-.816-.816-.653-1.796.816 0 .816-.816 1.796-.653 0 .49.653.49 1.143.653.653.817.49 2.123 1.796 2.286-.817 1.96-.49 5.225-3.429 5.388Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dn)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M66.286 82.612c.49 1.633 2.122-.98 2.939.653v.653c-1.47 0-3.266.164-4.082-.653v-.653z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__do)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M85.551 34.776c.98.326 3.429-.654 3.429.653v1.142c-1.143-.49-.327-1.795-1.796-.653-.327-.816-2.286-.163-2.286-1.142z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#logo_svg__dp)",
  fillRule: "evenodd",
  stroke: "#78A22F",
  strokeWidth: 0.14,
  d: "M87.837 82.122c.653.164.98-.163 1.143-.653.816 0 .816.817 1.795.653.49-.163.49.164.654.653-2.776-1.142-3.755 2.45-5.225.654.98-.164 1.47-.654 1.633-1.307Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006227",
  stroke: "#006227",
  d: "M190.204 36.408c0 5.714 0 10.286.327 12.735.163 1.633.489 2.939 2.285 3.265.817.163 2.123.163 2.613.163.326 0 .489.164.489.327q0 .49-.979.49c-3.266 0-7.021-.163-7.184-.163-.326 0-4.082.163-5.714.163q-.98 0-.98-.49c0-.163.163-.327.49-.327.49 0 1.306-.163 1.796-.163 1.143-.163 1.469-1.47 1.633-3.265.326-2.45.326-7.184.326-12.735v-6.204c0-.163-.163-.326-.326-.326h-25.143c-.164 0-.327 0-.327.326v6.204c0 5.714 0 10.286.327 12.735.163 1.633.489 2.939 2.285 3.265.817.163 2.123.163 2.613.163.326 0 .489.164.489.327q0 .49-.979.49c-3.265 0-7.021-.163-7.184-.163-.326 0-4.081.163-5.714.163q-.98 0-.98-.49c0-.163.164-.327.49-.327.49 0 1.306-.163 1.796-.163 1.143-.163 1.469-1.47 1.633-3.265.326-2.45.326-7.184.326-12.735V26.122c0-9.142 0-10.775-.163-12.734-.163-1.96-.653-2.939-2.612-3.429-.327-.163-1.306-.163-1.96-.163-.163 0-.489-.163-.489-.327q0-.49.979-.49c2.613 0 6.368.164 6.694.164.327 0 4.082-.163 5.714-.163q.98 0 .98.49c0 .163-.163.326-.49.326-.49 0-.816 0-1.469.163-1.633.327-2.123 1.306-2.123 3.429-.163 1.959-.163 3.592-.163 12.734v1.307c0 .326.163.326.327.326h24.979c.164 0 .327 0 .327-.326v-1.307c0-9.142 0-10.775-.163-12.734-.164-1.96-.654-2.939-2.449-3.429-.49-.163-1.47-.163-1.96-.163-.163 0-.489-.163-.489-.327q0-.49.979-.49c2.612 0 6.368.164 6.694.164.327 0 4.082-.163 5.714-.163q.98 0 .98.49c0 .163-.163.326-.49.326-.49 0-.816 0-1.469.163-1.633.327-2.123 1.306-2.123 3.429-.163 1.959-.163 3.592-.163 12.734zM201.143 48.816c-.163.164-.163.164-.327 0l-.816-.653c-.163-.163-.163-.326 0-.326l3.265-3.592c-2.775-2.939-4.081-6.857-4.081-10.612 0-6.041 4.408-14.694 14.857-14.694 4.081 0 7.183 1.143 9.796 3.102l3.102-3.265q.245-.246.489 0l.817.653q.245.244 0 .49l-3.102 3.265c2.449 2.449 3.755 5.714 3.755 9.959 0 8.49-6.041 15.347-15.021 15.347-3.918 0-7.183-1.143-9.469-3.102zM221.877 24c-2.122-2.612-5.061-3.755-8.163-3.755-6.204 0-10.939 4.081-10.939 12.408 0 3.755.98 6.857 2.613 9.306zm-15.51 19.265c2.123 2.45 5.062 3.755 8.49 3.755s10.449-1.959 10.449-12.898c0-3.591-.816-6.53-2.286-8.653zM239.674 37.061c0 5.551.163 8 .816 8.653s1.632.817 4.571.817c1.959 0 3.592 0 4.572-1.143.489-.653.816-1.47.979-2.286 0-.326.164-.49.327-.49s.163.163.163.49c0 .49-.326 2.612-.49 3.755-.326.816-.326.98-2.449.98-5.387 0-8-.164-10.122-.164h-3.5919999999999996c-.49 0-.653 0-.653-.326 0-.163 0-.163.326-.163.327 0 .817 0 1.143-.164.817-.163.98-.98 1.143-2.122.163-1.633.163-4.571.163-8.163V21.878c0-1.307-.326-1.96-1.632-2.123-.327 0-.98-.163-1.306-.163-.164 0-.327 0-.327-.163 0-.164.163-.327.653-.327 1.633 0 4.082.163 4.245.163s2.939-.163 4.082-.163c.49 0 .653 0 .653.327 0 .163-.163.163-.327.163-.326 0-.816 0-1.306.163-1.143.163-1.469.816-1.469 2.123V37.06zM266.122 20.408c.49-1.306.653-1.47.817-1.47s.326.164.816 1.307c.49 1.47 6.531 16.98 8.816 22.694 1.306 3.428 2.449 3.918 3.266 4.245.489.163 1.142.163 1.469.163.163 0 .326 0 .326.163s-.326.327-.816.327h-5.877c-.653 0-1.143 0-1.143-.327 0-.163.163-.163.326-.326.164 0 .49-.49.164-.98l-3.429-9.306c0-.163-.163-.163-.327-.163h-8.163c-.163 0-.326.163-.326.326l-2.286 6.694q-.49 1.47-.49 2.45c0 .815.816 1.142 1.469 1.142h.327c.327 0 .327 0 .327.163s-.164.327-.49.327c-.98 0-2.449-.164-2.939-.164s-2.449.164-4.245.164c-.49 0-.653 0-.653-.327 0-.163.163-.163.327-.163h1.142c1.796-.163 2.449-1.633 3.102-3.592zm3.919 15.02c.163 0 .163-.163.163-.326l-3.592-10.122q-.244-.735-.49 0l-3.265 10.122c0 .163 0 .327.163.327zM289.632 42.939c0 3.102.49 4.081 1.47 4.408.653.163 1.469.163 1.959.163.163 0 .327 0 .327.163 0 .164-.164.327-.653.327-2.123 0-3.592-.163-3.919-.163s-1.959.163-3.592.163c-.326 0-.653 0-.653-.327 0-.163.164-.163.327-.163.326 0 .979 0 1.469-.163.98-.327 1.143-1.306 1.143-4.735v-21.55c0-1.47.163-1.96.49-1.96s.979.816 1.306 1.143c.49.653 6.204 6.694 11.918 12.898 3.755 3.918 7.837 8.653 8.98 9.796l-.49-19.102c0-2.45-.326-3.266-1.469-3.592-.653-.163-1.47-.163-1.796-.163s-.327-.164-.327-.327.327-.326.817-.326c1.632 0 3.428.163 3.918.163s1.633-.163 3.265-.163c.49 0 .653 0 .653.326 0 .163-.163.327-.489.327-.164 0-.49 0-.98.163-1.306.326-1.469 1.143-1.469 3.428v22.041c0 2.45 0 2.613-.327 2.613-.326 0-.816-.49-2.775-2.45-.49-.326-5.878-5.877-9.796-10.285-4.409-4.735-8.653-9.47-9.796-10.776zM322.776 30.367v-8.163c0-1.306-.327-1.96-1.633-2.122-.327 0-.98-.164-1.306-.164-.163 0-.327 0-.327-.163s.164-.326.653-.326c1.633 0 4.082.163 4.245.163.49 0 2.776-.163 5.061-.163 3.756 0 10.613-.327 15.184 4.245 1.959 1.959 3.592 5.06 3.592 9.632 0 4.735-1.959 8.49-4.082 10.612-1.632 1.633-5.061 4.409-11.428 4.409-3.266 0-8-.49-8.327-.49-.163 0-2.612.163-3.755.163-.49 0-.653 0-.653-.327 0-.163 0-.163.327-.163.326 0 .816 0 1.142-.163.817-.163.98-.98 1.143-2.123.164-1.632.164-4.57.164-8.163zm3.265 4.082v8.163c0 .98.163 2.45.49 2.939.489.653 1.959 1.47 6.367 1.47 3.592 0 6.694-1.307 8.98-3.43 1.959-1.958 2.938-5.55 2.938-8.979 0-4.735-2.122-7.837-3.591-9.47-3.592-3.754-7.837-4.244-12.409-4.244-.816 0-2.122.163-2.449.326-.326.164-.489.327-.489.817v12.408000000000001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C1CD23",
  stroke: "#C1CD23",
  d: "M353.306 40.163c0-4.408 2.776-7.347 5.714-9.143-1.469-1.959-1.795-3.428-1.795-5.224 0-2.939 3.102-7.02 8.163-7.02 1.959 0 3.592.326 4.571.98.49.326.49.489.49.979 0 1.143-.163 3.755-.327 4.408-.163.49-.163.653-.326.653s-.163-.163-.163-.653c0-.98-.164-2.286-1.143-3.265-.816-.817-2.123-1.633-3.755-1.633-2.286 0-4.735 1.47-4.735 4.898 0 2.939 1.959 5.388 5.878 9.633 1.306 1.469 5.877 5.714 7.183 6.693.98-1.469 1.959-3.918 1.959-6.204 0-.49-.163-1.306-.653-1.796-.489-.49-1.306-.653-1.796-.653-.163 0-.489 0-.489-.326 0-.163.326-.327.653-.327.979 0 2.449 0 4.571.327.49 0 .653.326.653.816 0 3.102-2.122 6.857-3.755 8.98 2.449 2.122 4.082 3.102 5.225 3.755s3.102 1.47 4.408 1.47c.326 0 .49 0 .49.326 0 .163-.327.326-.653.326h-3.756c-2.775 0-3.755-.326-7.836-3.592-.817.817-3.919 4.082-9.47 4.082-6.694-.163-9.306-5.224-9.306-8.49Zm17.633 3.592c-2.123-1.796-5.878-5.388-6.857-6.367s-3.429-3.755-4.408-5.225c-1.96 1.306-3.429 3.266-3.429 6.368 0 4.734 3.265 8.163 7.51 8.163 3.592-.163 5.878-1.633 7.184-2.939Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006227",
  stroke: "#006227",
  d: "M390.531 52.735c-.817-.49-.817-.653-.817-2.286 0-2.939.164-5.224.327-6.204q0-.98.49-.98c.326 0 .489.164.489.653 0 .49 0 1.306.164 2.123.816 4.408 4.734 6.04 8.653 6.04 5.714 0 8.49-4.081 8.49-7.836 0-4.082-1.633-6.367-6.858-10.612l-2.612-2.123c-6.204-5.061-7.673-8.816-7.673-12.734 0-6.368 4.734-10.613 12.245-10.613 2.285 0 4.081.164 5.551.653 1.143.164 1.632.327 2.122.327s.653.163.653.49-.163 2.285-.163 6.204c0 .98-.163 1.306-.49 1.306s-.49-.327-.49-.817c0-.652-.489-2.285-.816-2.938s-1.959-3.102-7.347-3.102c-4.082 0-7.184 2.612-7.184 6.857 0 3.428 1.633 5.388 7.184 9.959l1.633 1.306c7.02 5.551 8.653 9.143 8.653 13.878 0 2.449-.98 6.857-5.061 9.796-2.613 1.796-5.715 2.449-8.817 2.449-3.102-.164-5.877-.653-8.326-1.796ZM420.245 30.367v-8.163c0-1.306-.327-1.96-1.633-2.122-.326 0-.979-.164-1.306-.164-.163 0-.327 0-.327-.163s.164-.326.654-.326c1.632 0 4.081.163 4.244.163h8.654c.653 0 1.306-.163 1.632-.163.163 0 .327-.164.49-.164s.163.164.163.327c0 .326-.163.653-.326 1.796 0 .326-.164 1.959-.164 2.449 0 .163-.163.49-.326.49s-.327-.164-.327-.49c0-.327 0-.98-.163-1.306-.326-.653-.653-.98-2.612-1.306-.653 0-4.735-.164-5.225-.164-.163 0-.163.163-.163.327v10.449c0 .326 0 .326.163.326h6.041c.98 0 1.47-.163 1.796-.49l.49-.49c.163 0 .163 0 .163.327 0 .163-.163.817-.326 2.123 0 .816-.164 2.122-.164 2.449s0 .653-.326.653c-.163 0-.327-.164-.327-.327 0-.326 0-.816-.163-1.306s-.49-1.143-1.959-1.306c-.98-.163-4.735-.163-5.388-.163a.35.35 0 0 0-.326.326v9.796c.163 2.612.653 3.102 4.408 3.102.979 0 2.612 0 3.592-.49.979-.49 1.469-1.142 1.632-2.775 0-.49.163-.49.327-.49.163 0 .163.327.163.49 0 .326-.326 2.939-.49 3.592-.326.98-.49.98-1.959.98-5.714 0-8.163-.164-9.306-.164h-3.5920000000000005c-.49 0-.653 0-.653-.327 0-.163 0-.163.327-.163.326 0 .816 0 1.142-.163.817-.163.98-.98 1.143-2.123.164-1.632.164-4.57.164-8.163v-6.694zM451.265 37.061c0 3.592 0 6.53.164 8.163.163 1.143.326 1.96 1.469 2.123.49 0 1.306.163 1.633.163.163 0 .326.163.326.163 0 .164-.163.327-.653.327-2.122 0-4.408-.163-4.571-.163-.164 0-2.613.163-3.755.163-.49 0-.654 0-.654-.327 0-.163 0-.163.327-.163.326 0 .816 0 1.143-.163.816-.163.979-.98 1.143-2.123.163-1.632.163-4.57.163-8.163v-16h-5.551c-2.286 0-3.265.327-3.918 1.143-.49.653-.49.98-.653 1.143-.164.326-.164.326-.327.326s-.163-.163-.163-.326c0-.327.816-3.592.816-3.918 0-.164.163-.653.327-.653.326 0 .653.326 1.632.49 1.143.163 2.612.163 2.939.163h14.204c1.143 0 2.123-.164 2.612-.164.49-.163.98-.163.98-.163.163 0 .163.163.163.49 0 1.143-.163 3.755-.163 4.082s-.163.49-.327.49c-.163 0-.326-.164-.326-.654v-.49c-.163-1.142-.98-1.959-4.572-2.122h-4.734v16.163zM466.449 47.51c-.49-.326-.49-.49-.49-1.47 0-1.958.163-3.428.163-3.917 0-.49.164-.654.327-.654s.326.164.326.49c0 .327 0 .816.164 1.47.489 2.775 3.102 3.918 5.551 3.918 3.591 0 5.387-2.612 5.387-5.061 0-2.613-1.142-4.082-4.408-6.857l-1.632-1.47c-3.919-3.265-4.898-5.55-4.898-8.163 0-4.082 2.938-6.857 7.836-6.857 1.47 0 2.613.163 3.429.326.653.164.98.164 1.306.164s.327 0 .327.326c0 .163-.164 1.47-.164 3.919 0 .652 0 .816-.326.816-.164 0-.327-.163-.327-.49 0-.49-.326-1.47-.49-1.96-.163-.489-1.306-1.958-4.734-1.958-2.612 0-4.572 1.632-4.572 4.408 0 2.122.98 3.428 4.572 6.367l.979.817c4.408 3.428 5.551 5.877 5.551 8.816 0 1.47-.653 4.408-3.265 6.204-1.633 1.143-3.592 1.633-5.714 1.633-1.633.163-3.429 0-4.898-.817ZM490.286 30.367v-8.163c0-1.306-.327-1.96-1.633-2.122-.326 0-.979-.164-1.306-.164-.163 0-.326 0-.326-.163s.163-.326.653-.326c1.632 0 3.918.163 4.081.163.327 0 2.449-.163 3.592-.163.49 0 .653 0 .653.326 0 .163-.163.163-.326.163-.327 0-.49 0-.98.164-.98.163-1.306.816-1.469 2.122v10.449h.163c.653-.653 7.51-7.673 8.816-9.143.98-1.143 1.959-2.122 1.959-2.775 0-.49-.163-.653-.489-.817a.35.35 0 0 1-.327-.326c0-.163.163-.327.49-.327.816 0 1.959.164 2.775.164.164 0 2.613-.164 3.592-.164.49 0 .49 0 .49.327 0 .163 0 .326-.327.326-.489 0-1.306.164-2.122.49-1.469.653-2.449 1.633-4.082 3.265-.979.98-7.51 7.347-8.326 8.327.979 1.143 8.816 9.143 10.449 10.612 3.102 2.939 3.755 3.592 5.551 4.245.979.49 2.122.49 2.286.49.326 0 .489 0 .489.163s-.163.327-.816.327h-4.571c-1.96-.164-2.939-.98-4.572-2.286-1.632-1.47-9.632-9.96-11.428-12.245h-.164v3.755c0 3.592 0 6.53.164 8.163.163 1.143.326 1.96 1.469 2.123.49 0 1.143.163 1.469.163.164 0 .327.163.327.163 0 .164-.163.327-.653.327-1.796 0-4.082-.163-4.408-.163s-2.449.163-3.592.163c-.49 0-.653 0-.653-.327 0-.163 0-.163.326-.163.327 0 .817 0 1.143-.163.816-.163.98-.98 1.143-2.123.163-1.632.163-4.57.163-8.163v-6.694zM529.469 18.939c8.49 0 14.858 5.387 14.858 14.204 0 8.49-6.041 15.347-15.021 15.347-10.286 0-14.694-8-14.694-14.857 0-6.041 4.408-14.694 14.857-14.694Zm.654 28.081c3.428 0 10.448-1.959 10.448-12.897 0-8.98-5.551-13.878-11.428-13.878-6.367 0-10.939 4.081-10.939 12.408-.163 8.816 5.225 14.367 11.919 14.367ZM571.265 38.367c0-3.102-.163-3.428-1.632-3.918-.327 0-.98-.163-1.306-.163-.164 0-.327 0-.327-.164 0-.163.163-.326.653-.326 1.633 0 4.082.163 4.245.163s2.612-.163 3.755-.163c.49 0 .653 0 .653.326 0 .164-.163.164-.326.164-.327 0-.49 0-.98.163-.979.163-1.306.816-1.469 2.122v8.164c0 1.632 0 1.796-.49 1.959-2.449 1.306-5.878 1.633-8 1.633-2.939 0-8.163-.327-12.408-4.082-2.286-1.96-4.408-6.04-4.408-10.776 0-6.04 2.938-10.285 6.367-12.408s7.184-2.449 9.959-2.449c2.449 0 5.061.49 5.714.653.817.164 2.123.327 3.102.327.327 0 .49.163.49.326 0 .49-.326 1.633-.326 5.388 0 .653 0 .816-.327.816-.163 0-.163-.163-.326-.49 0-.49-.164-1.632-.817-2.448-.979-1.47-4.081-3.102-8.816-3.102-2.449 0-5.224.163-8 2.449-2.122 1.796-3.755 5.224-3.755 9.632 0 5.388 2.612 9.143 3.918 10.45 2.939 2.938 6.368 4.08 9.959 4.08 1.307 0 3.266-.162 4.245-.815.49-.327.817-.654.817-1.307v-6.204zM241.306 109.388c-.816-.49-.816-.653-.816-2.286 0-2.939.163-5.224.326-6.204q0-.98.49-.98c.327 0 .49.164.49.653 0 .49 0 1.307.163 2.123.816 4.408 4.735 6.041 8.653 6.041 5.714 0 8.49-4.082 8.49-7.837 0-4.082-1.633-6.367-6.857-10.612l-2.612-2.123c-6.204-5.061-7.674-8.816-7.674-12.734 0-6.368 4.735-10.613 12.245-10.613 2.286 0 4.082.164 5.551.653 1.143.164 1.633.327 2.122.327.49 0 .654.163.654.49s-.164 2.285-.164 6.204c0 .98-.163 1.306-.49 1.306s-.489-.327-.489-.816c0-.654-.49-2.286-.817-2.94-.326-.652-1.959-3.101-7.347-3.101-4.081 0-7.183 2.612-7.183 6.857 0 3.428 1.632 5.388 7.183 9.96l1.633 1.305c7.021 5.551 8.653 9.143 8.653 13.878 0 2.449-.979 6.857-5.061 9.796-2.612 1.796-5.714 2.449-8.98 2.449-3.102-.327-5.714-.653-8.163-1.796ZM271.837 87.02v-8.163c0-1.306-.327-1.959-1.633-2.122-.327 0-.98-.164-1.306-.164-.163 0-.327 0-.327-.163s.164-.326.653-.326c1.633 0 3.919.163 4.245.163.817 0 2.939-.163 4.735-.163 4.735 0 6.367 1.632 7.02 2.122.817.816 1.96 2.45 1.96 4.408 0 5.388-3.919 8.98-9.307 8.98h-.816c-.163 0-.49 0-.49-.327 0-.326.164-.326.98-.326 3.592 0 6.53-2.612 6.53-6.204 0-1.306-.163-3.755-2.122-5.878-1.959-1.959-4.245-1.959-5.224-1.959-.654 0-1.307 0-1.633.163-.163 0-.327.327-.327.653v15.51c0 3.592 0 6.531.164 8.164.163 1.143.326 1.959 1.469 2.122.49 0 1.306.163 1.633.163.163 0 .326.164.326.164 0 .163-.163.326-.653.326-2.122 0-4.408-.163-4.571-.163-.164 0-2.449.163-3.592.163-.49 0-.653 0-.653-.326 0-.164 0-.164.326-.164.327 0 .817 0 1.143-.163.817-.163.98-.979 1.143-2.122.163-1.633.163-4.572.163-8.163V87.02zM299.755 77.061c.49-1.306.653-1.47.816-1.47.164 0 .327.164.817 1.307.49 1.47 6.53 16.98 8.816 22.694 1.306 3.428 2.449 3.918 3.265 4.245.49.163 1.143.163 1.47.163.163 0 .326 0 .326.163 0 .164-.326.327-.816.327h-5.878c-.653 0-1.142 0-1.142-.327 0-.163.163-.163.326-.326.163 0 .49-.49.163-.98l-3.428-9.306c0-.163-.164-.163-.327-.163H296c-.163 0-.327.163-.327.326l-2.285 6.694q-.49 1.47-.49 2.449c0 .816.816 1.143 1.469 1.143h.327c.326 0 .326 0 .326.163 0 .164-.163.327-.489.327-.98 0-2.449-.163-2.939-.163s-2.449.163-4.245.163c-.49 0-.653 0-.653-.327 0-.163.163-.163.326-.163h1.143c1.796-.163 2.449-1.633 3.102-3.592zm3.918 15.02c.164 0 .164-.163.164-.326l-3.592-10.122q-.245-.735-.49 0l-3.265 10.122c0 .163 0 .327.163.327zM320.653 87.02v-8.163c0-1.306-.327-1.959-1.633-2.122-.326 0-.979-.164-1.306-.164-.163 0-.326 0-.326-.163s.163-.326.653-.326c1.632 0 4.081.163 4.245.163.489 0 3.265-.163 4.408-.163 2.449 0 4.898.163 6.857 1.632.98.653 2.612 2.45 2.612 5.061 0 2.776-1.143 5.551-4.571 8.654 3.102 3.918 5.714 7.346 7.837 9.632 1.959 2.123 3.591 2.612 4.571 2.776a6.3 6.3 0 0 0 1.469.163c.164 0 .327.163.327.163 0 .164-.163.327-.98.327h-2.612c-2.122 0-3.102-.163-4.082-.653-1.632-.817-2.938-2.776-5.061-5.551-1.632-2.123-3.428-4.572-4.081-5.551-.164-.164-.327-.164-.49-.164h-4.572c-.163 0-.326.164-.326.327v.98c0 3.591 0 6.53.163 8.163.163 1.143.327 1.959 1.469 2.122.49 0 1.307.164 1.633.164.163 0 .327.163.327.163 0 .163-.164.326-.653.326-2.123 0-4.409-.163-4.572-.163 0 0-2.449.163-3.592.163-.489 0-.653 0-.653-.326 0-.163 0-.163.327-.163.326 0 .816 0 1.143-.164.816-.163.979-.979 1.142-2.122.164-1.633.164-4.572.164-8.163V87.02zm3.102 3.266c0 .163 0 .326.327.49.489.326 2.285.653 3.918.653.98 0 1.959-.164 2.775-.654 1.307-.98 2.286-2.938 2.286-5.877 0-4.735-2.449-7.51-6.53-7.51-1.143 0-2.123.163-2.449.163-.164 0-.327.163-.327.49zM350.694 87.02v-8.163c0-1.306-.327-1.959-1.633-2.122-.326 0-.979-.164-1.306-.164-.163 0-.326 0-.326-.163s.163-.326.653-.326c1.632 0 4.081.163 4.245.163h8.653c.653 0 1.306-.163 1.632-.163.164 0 .327-.164.49-.164s.163.164.163.327c0 .326-.163.653-.326 1.796 0 .326-.163 1.959-.163 2.449 0 .163-.164.49-.327.49s-.326-.164-.326-.49c0-.327 0-.98-.164-1.306-.326-.653-.653-.98-2.612-1.306-.653 0-4.735-.164-5.224-.164-.164 0-.164.163-.164.327V88.49c0 .326 0 .326.164.326h6.04c.98 0 1.47-.163 1.796-.49l.49-.49c.163 0 .163 0 .163.327 0 .163-.163.817-.326 2.123 0 .816-.163 2.122-.163 2.449s0 .653-.327.653c-.163 0-.326-.163-.326-.327 0-.326 0-.816-.164-1.306-.163-.49-.49-1.143-1.959-1.306-.98-.163-4.735-.163-5.388-.163-.163 0-.326.163-.326.326v9.633c.163 2.612.653 3.102 4.408 3.102.98 0 2.612 0 3.592-.49.979-.49 1.469-1.143 1.632-2.775 0-.49.164-.49.327-.49s.163.326.163.49c0 .326-.326 2.938-.49 3.591-.326.98-.489.98-1.959.98-5.714 0-8.163-.163-9.306-.163h-3.5920000000000005c-.49 0-.653 0-.653-.327 0-.163 0-.163.327-.163.326 0 .816 0 1.143-.163.816-.164.979-.98 1.142-2.123.164-1.632.164-4.571.164-8.163v-6.53zM372.082 87.02v-8.163c0-1.306-.327-1.959-1.633-2.122-.326 0-.98-.164-1.306-.164-.163 0-.327 0-.327-.163s.164-.326.653-.326c1.633 0 4.082.163 4.245.163.98 0 2.449-.163 4.082-.163 6.204 0 7.51 3.755 7.51 5.714 0 3.102-1.796 4.898-3.592 6.857 2.776.816 6.531 3.592 6.531 8 0 4.082-3.102 8.163-9.633 8.163-.816 0-4.734-.163-5.061-.163-.163 0-2.612.163-3.755.163-.49 0-.653 0-.653-.326 0-.163 0-.163.326-.163.327 0 .817 0 1.143-.164.817-.163.98-.979 1.143-2.122.163-1.633.163-4.572.163-8.163V87.02zm3.102.817c0 .326 0 .326.326.49.164 0 .98.163 2.286.163 2.122 0 2.612 0 3.429-.98s1.306-2.285 1.306-3.755c0-3.102-1.47-6.53-5.062-6.53-.489 0-1.142 0-1.795.163q-.49 0-.49.49zm0 3.918v8.163c.163 1.796.163 2.449 1.306 2.939.979.49 2.612.49 3.265.49 1.959 0 5.388-1.143 5.388-5.388 0-2.285-.816-5.55-3.592-7.51-1.306-.816-2.286-.98-3.102-1.143h-2.939c-.163 0-.163 0-.163.327v2.122zM403.266 77.061c.489-1.306.653-1.47.816-1.47s.326.164.816 1.307c.49 1.47 6.531 16.98 8.816 22.694 1.307 3.428 2.449 3.918 3.266 4.245.49.163 1.143.163 1.469.163.163 0 .327 0 .327.163 0 .164-.327.327-.817.327h-5.877c-.653 0-1.143 0-1.143-.327 0-.163.163-.163.327-.326.163 0 .489-.49.163-.98l-3.592-9.306c0-.163-.163-.163-.327-.163h-8.163a.35.35 0 0 0-.326.326l-2.286 6.694q-.49 1.47-.49 2.449c0 .816.816 1.143 1.47 1.143h.326c.327 0 .327 0 .327.163 0 .164-.164.327-.49.327-.98 0-2.449-.163-2.939-.163s-2.449.163-4.245.163c-.49 0-.653 0-.653-.327 0-.163.163-.163.327-.163h1.142c1.796-.163 2.449-1.633 3.102-3.592zm3.918 15.02c.163 0 .163-.163.163-.326l-3.592-10.122q-.245-.735-.489 0L400 91.755c0 .163 0 .327.163.327zM426.122 99.429c0 3.102.49 4.081 1.47 4.408.653.163 1.469.163 1.959.163.163 0 .326 0 .326.163 0 .164-.163.327-.653.327-2.122 0-3.592-.163-3.918-.163s-1.959.163-3.592.163c-.326 0-.653 0-.653-.327 0-.163.163-.163.327-.163.326 0 .979 0 1.469-.163.98-.327 1.143-1.306 1.143-4.735V77.551c0-1.47.163-1.96.49-1.96s.979.817 1.306 1.144c.49.653 6.204 6.694 11.918 12.898 3.755 3.918 7.837 8.653 8.98 9.796l-.49-19.103c0-2.448-.327-3.265-1.469-3.591-.654-.164-1.47-.164-1.796-.164s-.327-.163-.327-.326.327-.327.816-.327c1.633 0 3.429.164 3.919.164s1.632-.164 3.265-.164c.49 0 .653 0 .653.327 0 .163-.163.326-.49.326-.163 0-.489 0-.979.164-1.306.326-1.47 1.142-1.47 3.428v22.041c0 2.449 0 2.612-.326 2.612-.327 0-.816-.489-2.776-2.449-.489-.326-5.877-5.877-9.796-10.285-4.408-4.735-8.653-9.47-9.796-10.776zM460.082 87.02v-8.163c0-1.306-.327-1.959-1.633-2.122-.326 0-.98-.164-1.306-.164-.163 0-.327 0-.327-.163s.164-.326.654-.326c1.632 0 3.918.163 4.081.163.327 0 2.449-.163 3.592-.163.49 0 .653 0 .653.326 0 .163-.163.163-.327.163-.326 0-.489 0-.979.164-.98.163-1.306.816-1.469 2.122v10.449h.163c.653-.653 7.51-7.673 8.816-9.143.98-1.143 1.959-2.122 1.959-2.775 0-.49-.163-.653-.49-.817a.35.35 0 0 1-.326-.326c0-.163.163-.327.49-.327.816 0 1.959.164 2.775.164.164 0 2.613-.164 3.592-.164.49 0 .49 0 .49.327 0 .163 0 .326-.327.326-.489 0-1.306.164-2.122.49-1.469.653-2.449 1.633-4.082 3.265-.979.98-7.51 7.348-8.326 8.327.979 1.143 8.816 9.143 10.449 10.612 3.102 2.939 3.755 3.592 5.551 4.245.979.49 2.122.49 2.285.49.327 0 .49 0 .49.163 0 .164-.163.327-.816.327h-4.572c-1.959-.163-2.938-.98-4.571-2.286-1.633-1.469-9.633-9.96-11.428-12.245h-.164v3.755c0 3.592 0 6.531.164 8.164.163 1.142.326 1.959 1.469 2.122.49 0 1.143.163 1.469.163.164 0 .327.164.327.164 0 .163-.163.326-.653.326-1.796 0-4.082-.163-4.408-.163s-2.449.163-3.592.163c-.49 0-.653 0-.653-.326 0-.164 0-.164.326-.164.327 0 .817 0 1.143-.163.816-.163.98-.98 1.143-2.122.163-1.633.163-4.572.163-8.164V87.02z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__b",
  x1: 0,
  x2: 132.494,
  y1: 60.034,
  y2: 60.034,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.067,
  stopColor: "#B0BC22"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.132,
  stopColor: "#C0CA50"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.227,
  stopColor: "#D6DD8D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.315,
  stopColor: "#E8EBBE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.391,
  stopColor: "#F5F6E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.454,
  stopColor: "#FCFDF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.494,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.537,
  stopColor: "#FDFDF9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.593,
  stopColor: "#F7F8E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.656,
  stopColor: "#EEF0CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.723,
  stopColor: "#E0E5A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.795,
  stopColor: "#CFD77A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.869,
  stopColor: "#BBC540"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.904,
  stopColor: "#B0BC22"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__d",
  x1: 70.383,
  x2: 75.055,
  y1: 24.564,
  y2: 24.564,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__e",
  x1: 72.136,
  x2: 73.303,
  y1: 28.044,
  y2: 28.044,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__f",
  x1: 70.383,
  x2: 72.137,
  y1: 30.12,
  y2: 30.12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__g",
  x1: 52.876,
  x2: 54.045,
  y1: 30.982,
  y2: 30.982,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__h",
  x1: 75.033,
  x2: 76.222,
  y1: 31.274,
  y2: 31.274,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__i",
  x1: 103.69,
  x2: 105.986,
  y1: 57.198,
  y2: 57.198,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__j",
  x1: 83.808,
  x2: 85.499,
  y1: 65.502,
  y2: 65.502,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__k",
  x1: 86.136,
  x2: 88.637,
  y1: 67.978,
  y2: 67.978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__l",
  x1: 51.708,
  x2: 54.044,
  y1: 68.345,
  y2: 68.345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__m",
  x1: 64.47,
  x2: 65.132,
  y1: 71.25,
  y2: 71.25,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__n",
  x1: 47.621,
  x2: 50.542,
  y1: 77.925,
  y2: 77.925,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__o",
  x1: 46.386,
  x2: 48.215,
  y1: 78.541,
  y2: 78.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__p",
  x1: 45.8,
  x2: 48.571,
  y1: 79.715,
  y2: 79.715,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__q",
  x1: 85.543,
  x2: 87.893,
  y1: 82.05,
  y2: 82.05,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__r",
  x1: 26.024,
  x2: 27.781,
  y1: 82.021,
  y2: 82.021,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__s",
  x1: 28.364,
  x2: 31.282,
  y1: 82.049,
  y2: 82.049,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__t",
  x1: 68.048,
  x2: 72.136,
  y1: 82.288,
  y2: 82.288,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__u",
  x1: 93.083,
  x2: 94.865,
  y1: 82.086,
  y2: 82.086,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__v",
  x1: 33.032,
  x2: 35.367,
  y1: 82.341,
  y2: 82.341,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__w",
  x1: 53.439,
  x2: 55.794,
  y1: 82.328,
  y2: 82.328,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__x",
  x1: 54.627,
  x2: 59.879,
  y1: 23.395,
  y2: 23.395,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__y",
  x1: 34.785,
  x2: 47.624,
  y1: 35.651,
  y2: 35.651,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__z",
  x1: 28.489,
  x2: 33.033,
  y1: 46.448,
  y2: 46.448,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__A",
  x1: 28.673,
  x2: 31.282,
  y1: 51.096,
  y2: 51.096,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__B",
  x1: 26.03,
  x2: 31.274,
  y1: 56.284,
  y2: 56.284,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__C",
  x1: 19.027,
  x2: 23.11,
  y1: 63.109,
  y2: 63.109,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__D",
  x1: 13.774,
  x2: 18.442,
  y1: 65.725,
  y2: 65.725,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__E",
  x1: 16.692,
  x2: 21.362,
  y1: 72.729,
  y2: 72.729,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__F",
  x1: 23.696,
  x2: 41.786,
  y1: 73.841,
  y2: 73.841,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__G",
  x1: 43.536,
  x2: 46.457,
  y1: 73.038,
  y2: 73.038,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__H",
  x1: 25.447,
  x2: 34.785,
  y1: 80.59,
  y2: 80.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.112,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#9AB52B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.227,
  stopColor: "#709C2E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.301,
  stopColor: "#4D882E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.382,
  stopColor: "#2E792C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473,
  stopColor: "#096F2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#006828"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.717,
  stopColor: "#006427"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__I",
  x1: 28.948,
  x2: 33.032,
  y1: 82.681,
  y2: 82.681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__J",
  x1: 39.072,
  x2: 44.122,
  y1: 82.687,
  y2: 82.687,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__K",
  x1: 51.126,
  x2: 53.46,
  y1: 82.428,
  y2: 82.428,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__L",
  x1: 58.712,
  x2: 61.046,
  y1: 78.926,
  y2: 78.926,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__M",
  x1: 63.382,
  x2: 64.605,
  y1: 81.703,
  y2: 81.703,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__N",
  x1: 92.426,
  x2: 96.647,
  y1: 83.686,
  y2: 83.686,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__O",
  x1: 97.816,
  x2: 101.152,
  y1: 82.764,
  y2: 82.764,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006227"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.343,
  stopColor: "#006327"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#006728"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.613,
  stopColor: "#066E2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.71,
  stopColor: "#2C782C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.796,
  stopColor: "#4A862E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.873,
  stopColor: "#6C992E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.942,
  stopColor: "#94B22C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C1CD23"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__P",
  x1: 89.04,
  x2: 98.397,
  y1: 75.104,
  y2: 75.104,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__Q",
  x1: 102.484,
  x2: 106.022,
  y1: 75.353,
  y2: 75.353,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__R",
  x1: 107.736,
  x2: 114.155,
  y1: 70.667,
  y2: 70.667,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__S",
  x1: 115.322,
  x2: 121.741,
  y1: 71.863,
  y2: 71.863,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__T",
  x1: 121.158,
  x2: 125.873,
  y1: 66.305,
  y2: 66.305,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__U",
  x1: 118.24,
  x2: 120.574,
  y1: 62.494,
  y2: 62.494,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__V",
  x1: 111.821,
  x2: 118.24,
  y1: 58.996,
  y2: 58.996,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__W",
  x1: 101.312,
  x2: 111.237,
  y1: 52.933,
  y2: 52.933,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__X",
  x1: 89.061,
  x2: 91.977,
  y1: 37.109,
  y2: 37.109,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__Y",
  x1: 84.391,
  x2: 85.6,
  y1: 33.608,
  y2: 33.608,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__Z",
  x1: 81.474,
  x2: 84.391,
  y1: 30.985,
  y2: 30.985,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aa",
  x1: 56.214,
  x2: 69.801,
  y1: 27.059,
  y2: 27.059,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ab",
  x1: 59.879,
  x2: 62.338,
  y1: 22.806,
  y2: 22.806,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ac",
  x1: 57.545,
  x2: 61.067,
  y1: 22.809,
  y2: 22.809,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ad",
  x1: 52.877,
  x2: 65.236,
  y1: 27.305,
  y2: 27.305,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ae",
  x1: 66.882,
  x2: 69.801,
  y1: 23.688,
  y2: 23.688,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__af",
  x1: 77.387,
  x2: 81.473,
  y1: 27.479,
  y2: 27.479,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ag",
  x1: 81.474,
  x2: 84.975,
  y1: 32.149,
  y2: 32.149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ah",
  x1: 87.309,
  x2: 96.647,
  y1: 39.211,
  y2: 39.211,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ai",
  x1: 97.231,
  x2: 98.995,
  y1: 42.065,
  y2: 42.065,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aj",
  x1: 100.129,
  x2: 103.641,
  y1: 54.954,
  y2: 54.954,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ak",
  x1: 101.91,
  x2: 113.571,
  y1: 57.538,
  y2: 57.538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__al",
  x1: 114.739,
  x2: 125.328,
  y1: 64.248,
  y2: 64.248,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__am",
  x1: 114.739,
  x2: 124.077,
  y1: 71.538,
  y2: 71.538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__an",
  x1: 109.484,
  x2: 112.404,
  y1: 70.025,
  y2: 70.025,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ao",
  x1: 105.402,
  x2: 108.903,
  y1: 72.208,
  y2: 72.208,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ap",
  x1: 101.9,
  x2: 105.407,
  y1: 75.074,
  y2: 75.074,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aq",
  x1: 91.394,
  x2: 97.102,
  y1: 74.267,
  y2: 74.267,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ar",
  x1: 83.808,
  x2: 86.725,
  y1: 71.252,
  y2: 71.252,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__as",
  x1: 76.803,
  x2: 82.057,
  y1: 70.585,
  y2: 70.585,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__at",
  x1: 77.972,
  x2: 79.732,
  y1: 68.364,
  y2: 68.364,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__au",
  x1: 72.136,
  x2: 78.049,
  y1: 65.133,
  y2: 65.133,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__av",
  x1: 70.21,
  x2: 72.719,
  y1: 70.367,
  y2: 70.367,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aw",
  x1: 72.719,
  x2: 80.89,
  y1: 75.71,
  y2: 75.71,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ax",
  x1: 86.725,
  x2: 89.061,
  y1: 81.476,
  y2: 81.476,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ay",
  x1: 74.469,
  x2: 86.143,
  y1: 81.174,
  y2: 81.174,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__az",
  x1: 66.87,
  x2: 72.137,
  y1: 77.091,
  y2: 77.091,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aA",
  x1: 65.132,
  x2: 66.882,
  y1: 72.42,
  y2: 72.42,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aB",
  x1: 63.313,
  x2: 66.298,
  y1: 73.877,
  y2: 73.877,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aC",
  x1: 66.298,
  x2: 70.968,
  y1: 80.882,
  y2: 80.882,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aD",
  x1: 60.36,
  x2: 63.964,
  y1: 79.451,
  y2: 79.451,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aE",
  x1: 61.046,
  x2: 62.145,
  y1: 75.338,
  y2: 75.338,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aF",
  x1: 58.712,
  x2: 60.464,
  y1: 70.972,
  y2: 70.972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aG",
  x1: 58.079,
  x2: 59.901,
  y1: 73.002,
  y2: 73.002,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aH",
  x1: 54.044,
  x2: 59.295,
  y1: 80.014,
  y2: 80.014,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aI",
  x1: 52.272,
  x2: 53.465,
  y1: 80.882,
  y2: 80.882,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aJ",
  x1: 40.619,
  x2: 57.545,
  y1: 76.505,
  y2: 76.505,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#BAC925"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.058,
  stopColor: "#8BAC2D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.116,
  stopColor: "#64952E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#45842D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.253,
  stopColor: "#28762C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.337,
  stopColor: "#006D2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.441,
  stopColor: "#006728"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.588,
  stopColor: "#006327"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aK",
  x1: 49.938,
  x2: 51.595,
  y1: 71.624,
  y2: 71.624,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aL",
  x1: 41.204,
  x2: 47.039,
  y1: 72.369,
  y2: 72.369,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aM",
  x1: 33.018,
  x2: 38.285,
  y1: 73.907,
  y2: 73.907,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aN",
  x1: 25.447,
  x2: 32.449,
  y1: 72.401,
  y2: 72.401,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aO",
  x1: 17.857,
  x2: 23.11,
  y1: 72.069,
  y2: 72.069,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aP",
  x1: 10.854,
  x2: 30.698,
  y1: 61.602,
  y2: 61.602,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aQ",
  x1: 31.282,
  x2: 33.616,
  y1: 56.149,
  y2: 56.149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aR",
  x1: 32.436,
  x2: 38.216,
  y1: 56.723,
  y2: 56.723,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aS",
  x1: 38.868,
  x2: 40.619,
  y1: 58.12,
  y2: 58.12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aT",
  x1: 40.619,
  x2: 45.873,
  y1: 55.669,
  y2: 55.669,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aU",
  x1: 48.206,
  x2: 51.229,
  y1: 52.288,
  y2: 52.288,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aV",
  x1: 45.289,
  x2: 47.624,
  y1: 52.285,
  y2: 52.285,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aW",
  x1: 44.121,
  x2: 46.457,
  y1: 51.7,
  y2: 51.7,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aX",
  x1: 29.473,
  x2: 34.761,
  y1: 49.602,
  y2: 49.602,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aY",
  x1: 36.534,
  x2: 38.292,
  y1: 41.779,
  y2: 41.779,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__aZ",
  x1: 37.791,
  x2: 40.108,
  y1: 37.694,
  y2: 37.694,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ba",
  x1: 38.868,
  x2: 45.872,
  y1: 34.483,
  y2: 34.483,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bb",
  x1: 45.96,
  x2: 54.648,
  y1: 33.915,
  y2: 33.915,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bc",
  x1: 48.789,
  x2: 53.46,
  y1: 28.356,
  y2: 28.356,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bd",
  x1: 57.545,
  x2: 60.483,
  y1: 33.316,
  y2: 33.316,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__be",
  x1: 51.708,
  x2: 55.794,
  y1: 37.109,
  y2: 37.109,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bf",
  x1: 51.096,
  x2: 53.405,
  y1: 37.704,
  y2: 37.704,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bg",
  x1: 53.46,
  x2: 59.396,
  y1: 37.701,
  y2: 37.701,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bh",
  x1: 59.867,
  x2: 63.382,
  y1: 34.192,
  y2: 34.192,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bi",
  x1: 60.462,
  x2: 65.598,
  y1: 32.093,
  y2: 32.093,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bj",
  x1: 64.547,
  x2: 66.303,
  y1: 31.08,
  y2: 31.08,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bk",
  x1: 66.034,
  x2: 71.552,
  y1: 28.883,
  y2: 28.883,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bl",
  x1: 66.882,
  x2: 72.152,
  y1: 32.962,
  y2: 32.962,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bm",
  x1: 75.636,
  x2: 78.186,
  y1: 32.445,
  y2: 32.445,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bn",
  x1: 72.719,
  x2: 75.636,
  y1: 29.242,
  y2: 29.242,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bo",
  x1: 66.882,
  x2: 69.801,
  y1: 25.792,
  y2: 25.792,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bp",
  x1: 68.037,
  x2: 71.552,
  y1: 27.831,
  y2: 27.831,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bq",
  x1: 71.552,
  x2: 73.887,
  y1: 28.064,
  y2: 28.064,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__br",
  x1: 47.609,
  x2: 50.226,
  y1: 27.963,
  y2: 27.963,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bs",
  x1: 72.137,
  x2: 74.491,
  y1: 29.232,
  y2: 29.232,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bt",
  x1: 79.723,
  x2: 81.336,
  y1: 27.136,
  y2: 27.136,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bu",
  x1: 50.596,
  x2: 52.876,
  y1: 30.637,
  y2: 30.637,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bv",
  x1: 49.959,
  x2: 52.293,
  y1: 31.546,
  y2: 31.546,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bw",
  x1: 60.46,
  x2: 63.382,
  y1: 31.886,
  y2: 31.886,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bx",
  x1: 68.043,
  x2: 70.968,
  y1: 30.69,
  y2: 30.69,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__by",
  x1: 75.636,
  x2: 77.972,
  y1: 31.643,
  y2: 31.643,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bz",
  x1: 58.687,
  x2: 60.462,
  y1: 31.566,
  y2: 31.566,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bA",
  x1: 75.636,
  x2: 76.891,
  y1: 31.59,
  y2: 31.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bB",
  x1: 58.116,
  x2: 61.63,
  y1: 34.775,
  y2: 34.775,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bC",
  x1: 47.039,
  x2: 50.646,
  y1: 33.688,
  y2: 33.688,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bD",
  x1: 56.377,
  x2: 59.879,
  y1: 35.372,
  y2: 35.372,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bE",
  x1: 55.21,
  x2: 57.679,
  y1: 35.651,
  y2: 35.651,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bF",
  x1: 53.46,
  x2: 56.377,
  y1: 37.059,
  y2: 37.059,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bG",
  x1: 49.263,
  x2: 52.876,
  y1: 40.611,
  y2: 40.611,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bH",
  x1: 48.673,
  x2: 50.542,
  y1: 41.149,
  y2: 41.149,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bI",
  x1: 91.913,
  x2: 93.728,
  y1: 40.32,
  y2: 40.32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bJ",
  x1: 33.033,
  x2: 34.279,
  y1: 44.989,
  y2: 44.989,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bK",
  x1: 47.625,
  x2: 50.546,
  y1: 51.993,
  y2: 51.993,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bL",
  x1: 41.786,
  x2: 46.458,
  y1: 54.044,
  y2: 54.044,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bM",
  x1: 41.786,
  x2: 45.301,
  y1: 56.061,
  y2: 56.061,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bN",
  x1: 41.713,
  x2: 44.121,
  y1: 53.452,
  y2: 53.452,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bO",
  x1: 34.13,
  x2: 40.618,
  y1: 55.494,
  y2: 55.494,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bP",
  x1: 30.698,
  x2: 34.785,
  y1: 54.301,
  y2: 54.301,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bQ",
  x1: 34.158,
  x2: 40.035,
  y1: 56.953,
  y2: 56.953,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bR",
  x1: 38.868,
  x2: 40.619,
  y1: 56.674,
  y2: 56.674,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bS",
  x1: 24.863,
  x2: 28.364,
  y1: 58.079,
  y2: 58.079,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bT",
  x1: 115.906,
  x2: 118.24,
  y1: 60.455,
  y2: 60.455,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bU",
  x1: 96.737,
  x2: 100.011,
  y1: 61.877,
  y2: 61.877,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bV",
  x1: 99.544,
  x2: 102.506,
  y1: 65.99,
  y2: 65.99,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bW",
  x1: 97.231,
  x2: 99.05,
  y1: 61.267,
  y2: 61.267,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bX",
  x1: 119.407,
  x2: 122.326,
  y1: 63.957,
  y2: 63.957,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bY",
  x1: 99.565,
  x2: 101.315,
  y1: 64.527,
  y2: 64.527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__bZ",
  x1: 70.968,
  x2: 73.304,
  y1: 64.541,
  y2: 64.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ca",
  x1: 75.054,
  x2: 76.816,
  y1: 64.524,
  y2: 64.524,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cb",
  x1: 83.786,
  x2: 86.285,
  y1: 65.679,
  y2: 65.679,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cc",
  x1: 80.306,
  x2: 84.391,
  y1: 70.419,
  y2: 70.419,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cd",
  x1: 75.054,
  x2: 82.057,
  y1: 75.64,
  y2: 75.64,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ce",
  x1: 72.137,
  x2: 73.419,
  y1: 71.274,
  y2: 71.274,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cf",
  x1: 70.968,
  x2: 72.105,
  y1: 66.874,
  y2: 66.874,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cg",
  x1: 83.235,
  x2: 86.725,
  y1: 66.291,
  y2: 66.291,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ch",
  x1: 9.688,
  x2: 13.774,
  y1: 66.585,
  y2: 66.585,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ci",
  x1: 86.136,
  x2: 88.637,
  y1: 67.978,
  y2: 67.978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cj",
  x1: 52.876,
  x2: 54.704,
  y1: 69.5,
  y2: 69.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ck",
  x1: 121.741,
  x2: 124.729,
  y1: 71.817,
  y2: 71.817,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cl",
  x1: 114.155,
  x2: 115.906,
  y1: 72.123,
  y2: 72.123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cm",
  x1: 58.687,
  x2: 61.631,
  y1: 73.587,
  y2: 73.587,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cn",
  x1: 21.362,
  x2: 25.446,
  y1: 72.992,
  y2: 72.992,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__co",
  x1: 47.625,
  x2: 50.545,
  y1: 73.39,
  y2: 73.39,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cp",
  x1: 64.547,
  x2: 68.634,
  y1: 75.058,
  y2: 75.058,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cq",
  x1: 65.69,
  x2: 67.467,
  y1: 77.198,
  y2: 77.198,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cr",
  x1: 63.314,
  x2: 65.132,
  y1: 75.186,
  y2: 75.186,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cs",
  x1: 59.295,
  x2: 61.046,
  y1: 76.505,
  y2: 76.505,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__ct",
  x1: 101.315,
  x2: 103.651,
  y1: 75.677,
  y2: 75.677,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cu",
  x1: 66.228,
  x2: 69.216,
  y1: 78.548,
  y2: 78.548,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cv",
  x1: 42.371,
  x2: 46.458,
  y1: 77.377,
  y2: 77.377,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cw",
  x1: 49.934,
  x2: 55.794,
  y1: 78.256,
  y2: 78.256,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cx",
  x1: 80.889,
  x2: 92.562,
  y1: 78.847,
  y2: 78.847,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cy",
  x1: 45.817,
  x2: 51.708,
  y1: 80.598,
  y2: 80.598,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cz",
  x1: 69.216,
  x2: 73.304,
  y1: 78.843,
  y2: 78.843,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cA",
  x1: 35.367,
  x2: 38.868,
  y1: 81.409,
  y2: 81.409,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cB",
  x1: 34.785,
  x2: 42.8,
  y1: 80.01,
  y2: 80.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.112,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#9AB52B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.227,
  stopColor: "#709C2E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.301,
  stopColor: "#4D882E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.382,
  stopColor: "#2E792C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473,
  stopColor: "#096F2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#006828"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.717,
  stopColor: "#006427"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cC",
  x1: 30.715,
  x2: 35.971,
  y1: 80.808,
  y2: 80.808,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cD",
  x1: 42.371,
  x2: 45.289,
  y1: 80.245,
  y2: 80.245,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cE",
  x1: 73.303,
  x2: 77.972,
  y1: 81.79,
  y2: 81.79,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cF",
  x1: 50.507,
  x2: 54.08,
  y1: 81.825,
  y2: 81.825,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cG",
  x1: 44.121,
  x2: 46.457,
  y1: 81.757,
  y2: 81.757,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cH",
  x1: 32.669,
  x2: 35.367,
  y1: 81.174,
  y2: 81.174,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cI",
  x1: 23.696,
  x2: 28.364,
  y1: 81.768,
  y2: 81.768,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.112,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#9AB52B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.227,
  stopColor: "#709C2E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.301,
  stopColor: "#4D882E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.382,
  stopColor: "#2E792C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.473,
  stopColor: "#096F2A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#006828"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.717,
  stopColor: "#006427"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cJ",
  x1: 83.222,
  x2: 86.148,
  y1: 81.998,
  y2: 81.998,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cK",
  x1: 91.258,
  x2: 96.647,
  y1: 80.593,
  y2: 80.593,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cL",
  x1: 70.383,
  x2: 74.469,
  y1: 82.629,
  y2: 82.629,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cM",
  x1: 69.216,
  x2: 75.459,
  y1: 82.632,
  y2: 82.632,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006227"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.251,
  stopColor: "#006427"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#006829"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.541,
  stopColor: "#12702A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#357C2D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.769,
  stopColor: "#558D2E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.871,
  stopColor: "#7CA32E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.966,
  stopColor: "#ADC028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C1CD23"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cN",
  x1: 88.428,
  x2: 97.252,
  y1: 80.731,
  y2: 80.731,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006227"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.163,
  stopColor: "#23752B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.444,
  stopColor: "#67972E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.688,
  stopColor: "#96B32C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.881,
  stopColor: "#B5C626"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C1CD23"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cO",
  x1: 96.647,
  x2: 100.73,
  y1: 82.924,
  y2: 82.924,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cP",
  x1: 51.126,
  x2: 52.293,
  y1: 26.606,
  y2: 26.606,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cQ",
  x1: 51.21,
  x2: 52.876,
  y1: 30.982,
  y2: 30.982,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cR",
  x1: 66.882,
  x2: 70.095,
  y1: 34.19,
  y2: 34.19,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cS",
  x1: 55.21,
  x2: 56.961,
  y1: 34.775,
  y2: 34.775,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cT",
  x1: 35.947,
  x2: 38.868,
  y1: 58.957,
  y2: 58.957,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cU",
  x1: 76.79,
  x2: 79.19,
  y1: 68.359,
  y2: 68.359,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cV",
  x1: 12.023,
  x2: 14.356,
  y1: 71.848,
  y2: 71.848,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cW",
  x1: 13.771,
  x2: 16.692,
  y1: 72.458,
  y2: 72.458,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cX",
  x1: 38.133,
  x2: 41.204,
  y1: 73.853,
  y2: 73.853,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cY",
  x1: 45.289,
  x2: 47.644,
  y1: 73.003,
  y2: 73.003,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__cZ",
  x1: 63.964,
  x2: 65.132,
  y1: 73.295,
  y2: 73.295,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__da",
  x1: 59.295,
  x2: 61.081,
  y1: 73.816,
  y2: 73.816,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__db",
  x1: 87.892,
  x2: 89.643,
  y1: 73.899,
  y2: 73.899,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dc",
  x1: 90.226,
  x2: 91.393,
  y1: 74.754,
  y2: 74.754,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dd",
  x1: 105.402,
  x2: 107.778,
  y1: 73.879,
  y2: 73.879,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__de",
  x1: 47.625,
  x2: 51.126,
  y1: 76.505,
  y2: 76.505,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__df",
  x1: 35.367,
  x2: 40.619,
  y1: 79.121,
  y2: 79.121,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dg",
  x1: 68.531,
  x2: 73.671,
  y1: 80.006,
  y2: 80.006,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006227"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.251,
  stopColor: "#006427"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#006829"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.541,
  stopColor: "#12702A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#357C2D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.769,
  stopColor: "#558D2E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.871,
  stopColor: "#7CA32E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.966,
  stopColor: "#ADC028"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C1CD23"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dh",
  x1: 34.785,
  x2: 37.702,
  y1: 81.746,
  y2: 81.746,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__di",
  x1: 38.868,
  x2: 42.374,
  y1: 81.504,
  y2: 81.504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dj",
  x1: 77.972,
  x2: 80.893,
  y1: 82.302,
  y2: 82.302,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dk",
  x1: 70.968,
  x2: 76.803,
  y1: 24.211,
  y2: 24.211,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dl",
  x1: 59.295,
  x2: 60.827,
  y1: 31.837,
  y2: 31.837,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dm",
  x1: 49.934,
  x2: 54.627,
  y1: 72.116,
  y2: 72.116,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dn",
  x1: 65.132,
  x2: 69.216,
  y1: 83.228,
  y2: 83.228,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__do",
  x1: 84.974,
  x2: 89.061,
  y1: 35.61,
  y2: 35.61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__dp",
  x1: 86.143,
  x2: 91.394,
  y1: 82.614,
  y2: 82.614,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.332,
  stopColor: "#C1CD23"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.994,
  stopColor: "#006227"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "logo_svg__c",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(66.678 60.251)scale(59.4991)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.153,
  stopColor: "#FEFEFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#FAFBF1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#F3F5DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.546,
  stopColor: "#EAEDC5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.67,
  stopColor: "#DEE3A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.791,
  stopColor: "#D0D77B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.909,
  stopColor: "#BFC94C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B0BC22"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "logo_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h578v120H0z"
})))));
export default SvgLogo;